import React, { useState, useRef, useEffect } from "react";
import "./ExamCenter.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CSVLink } from "react-csv";
import "jspdf-autotable";
import ListInfo from "../BookModule/BookModule.module.css";
import Chip from "@mui/material/Chip";
import { Download } from "@mui/icons-material";
import IconAnalytics from "@mui/icons-material/Assignment";
import Paper from "@mui/material/Paper";
import { AxiosInstance } from "../../../../axios";
import { ImageUrlPrefix, R_PER_PAGE } from "../../../../labels";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import "react-datepicker/dist/react-datepicker.css";
import MyCalendar from "./CalendarView";
import Swal from "sweetalert2";
import ReviewstatusCheck from "./ReviewstatusCheck";
import ReviewMockPanelMember from "./ReviewMockPanelMember";
import ReviewFeesDetails from "./ReviewFeesDetails";
import ReviewCounselingPanel from "./ReviewCounselingPanel";
import ModelComForP from "../../../../pages/ModelComForP";
import GenarateHallTicket from "./GenarateHallTicket";
import GenarateAttentenceSheet from "./GenarateAttentenceSheet";
import { Dialog, DialogContent, Switch } from "@mui/material";
import Loader from "../../Loader";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import { ExportTableToPdf } from "../../../ReusuableComponent/ExportTableToPdf";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import DatePickerSample from "../../DatePicker";

  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));
function ReadViewBath() {
  const moment = require("moment-timezone");
  const [listData, setListData] = useState([]);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const txtBSearch = useRef(null); //Search icon
  const [emails, setEmails] = useState([]);
  const {
    MODE,
    GENDER,
    EXAMDISTRICT,
    SEARCHTERM,
    PAYMENTMODE,
    CORESUBJECT,
    DATEFILTERS,
    MEDIUMSTUDIED,
  } = location.state || {};
  const { id, type } = useParams();
  const { type: typeFromParam } = useParams();
  const { id: API_BATCH_ID } = useParams();
  const { FSF, FCAF, FCM, FIT, FME, FLO, FSP, FSTD, FCON, ftype, FSEAR } =
    location.state ? location.state : {};
  const menuList = JSON.parse(sessionStorage.getItem("menu_list")) || [];
  const userJSON = sessionStorage.getItem("userDetails");
  let user_type = null;
  let staff_id = null;
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
      staff_id = user.staff_id;
    }
    if (user && user.user_type) {
      user_type = user.user_type;
    }
  } else {
    console.log("user not available in session storage");
  }

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);
  const currentDate = moment();
  const startOfDay = moment(currentDate).startOf("day");
  const tenAMModelExam = startOfDay.clone().hour(10);
  const [modelExamRecentObj, setModelExamRecentObj] = useState(currentDate);
  const [formFields, setFormFields] = useState({
    Name: "",
    Section: "",
    Category: "",
    Course: "",
    category_course_id: "", //new change
    subCate: "",
    batchImg: null,
    original_img_url: null,
    ClassMode: "",
    MediumInstruction: "",
    SchedulePreference: "",
    StartDate: "",
    endDate: "",
    Time: "",
    endTime: "",
    Duration: "",
    NoStudents: "",
    NoTest: "",
    subject: "",
    TestPdf: null,
    original_test_img_url: null,
    exampassed: "",
    EnrollStu: "",
    Fees: "",
    Discount: "",
    OldsDiscount: "",
    OldSBatch: "",
    message: "",
    location: "",
    LastDateApply: false,
    ask_core_exam: "",
    subject_file_path: null,
    original_subject_file_path: null,
    pPayment: "",
    perOne: "",
    perTwo: "",
    perTwoDate: "",
    perThree: "",
    perThreeDate: "",
    Papers: "",
    NModelExam: "",
    MNPapers: "",
    MExamTitle: "",
  });
  const [csvListData, setCsvListData] = useState([]);
  const [selectedDistrict, setSelectDistrict] = useState([]);
  const [selectedDistricts, setSelectDistricts] = useState([]);
  const [examWiseEnroll, setExamWiseEnroll] = useState([]);
  const [openHallModal, setOpenHallModal] = useState(false);
  const [openAttenModal, setOpenAttenModal] = useState(false);
  const [hallTicketData, setHallTicketData] = useState([]);
  const [oth_app_batch, set_oth_app_batch] = useState([]);
  const [mediums, setMedium] = useState([]);
  const [attentData, setAttentData] = useState([]);
  const [coreSubjects, setCoreSubjects] = useState([]);
  const [coreSubjectsOptions, setCoreSubjectsOptions] = useState([]);
  const [interviews, setInterviews] = useState([]);

  const handleChangeRadio = (pk) => {
    if (pk) {
      AxiosInstance.post("api/batch/meSupervisor/redwnld/approve", {
        batch_id: id,
        exam_center_cstm_pk: pk,
        updated_by: userid,
        type: parseInt(type),
      })
        .then((res) => {
          if (res.data.status === true) {
            FindById();
          } else {
            Swal.fire({
              title: "Warning",
              text: res.data.message,
              icon: "Warning",
              confirmButtonText: "Ok",
            });
          }
        })
        .catch((error) => {
          return error;
        });
    }
  };
  // panel details for mock interview

  const [mockPanel, setMockPanel] = useState([
    {
      id: 1,
      panel_name: "",
      available_dates: [],
      panelMem: [],
      staffMem: [],
      fees: "",
      error_1: "",
      error_2: "",
      error_3: "",
      error_4: "",
      error_5: "",
    },
  ]);
  // panel details for Counselling

  const [cPanel, setCPanel] = useState([
    {
      id: 1,
      panel_name: "",
      date: "",
      StartTime: "",
      EndTime: "",
      department: [],
      CPaneMem: [],
      CStaffM: [],
      fees: "",
      error_1: "",
      error_2: "",
      error_3: "",
      error_4: "",
      error_5: "",
      error_6: "",
      error_7: "",
      error_8: "",
    },
  ]);

  const [mExamSF, setMExamSF] = useState([
    {
      id: 1,
      NoStudentBatch: "",
      SOfferDis: 0,
      selectedOptions: [],
      ApplicableBatch: [],
      MEABatch: "",
      StudentBatchCount: "",
      error_1: "",
      error_2: "",
      error_3: "",
      error_4: "",
    },
  ]);

  useEffect(() => {
    FindById();
  }, []);

  const FindById = () => {
    if (id) {
      setIsLoading(true);
      AxiosInstance.post("/api/batch/findById", {
        id: id,
        start_date: moment().startOf("month").format("YYYY-MM-DD"),
        end_date: moment().endOf("month").format("YYYY-MM-DD"),
      })
        .then((res) => {
          if (res.data.status === true) {
            if (res.data.data.batch_students_info.length > 0) {
              const emails = res.data.data.batch_students_info.map(
                (student) => student.email
              );
              set_oth_app_batch(res.data.data.other_app_batch);
              setEmails(emails);
              const Info_student = res.data.data.batch_students_info.map(
                (data, index) => ({
                  ...data,
                  serialNumber: index + 1,
                })
              );
              setListData(Info_student);
              // setUpdateListData(Info_student);
            }
            if (
              res.data.data.event_list &&
              res.data.data.event_list.length > 0
            ) {
              const parsedEvents = res.data.data.event_list.map((event) => {
                const startDateStr = `${event.start_date.split("T")[0]}T${event.start_time
                  }`;
                const endDateStr = `${event.start_date.split("T")[0]}T${event.end_time
                  }`;
                const startDate = moment(startDateStr).toDate();
                const endDate = moment(endDateStr).toDate();
                return {
                  id: event.id,
                  title: event.name,
                  event_type: event.event_type,
                  start: startDate,
                  end: endDate,
                  url: event.teams_url,
                  subject: event.subject,
                  staff_name: event.staff_name,
                  staff_id: event.staff_id,
                  description: event.description,
                  syllabus_filepath: event.syllabus_filepath,
                };
              });
              setEventFields(parsedEvents);
            }
            if (Object.keys(res.data.data.batch_info).length > 0) {
              let dateLast =
                res.data.data.batch_info.apply_last_date !== null
                  ? res.data.data.batch_info.apply_last_date
                  : "";
              const desiredDateTime = moment(dateLast);
              const currentDateTime = moment();
              const item = res.data.data.batch_info;
              const centreSupervisorName =
                res.data?.data?.batch_exam_center.map((data) => {
                  return data.exam_center_name;
                });
              setFormFields({
                Name: item.name,
                Section: item.section,
                Papers: item.paper_type === 0 ? "0" : "1",
                Category: item.category,
                Course: item.category_class,
                subCate: item.subcategory,
                ClassMode: item.class_mode,
                category_course_id: item.category_course_id,
                batchImg: item.img_url != null ? item.img_url : null,
                original_img_url:
                  item.original_img_url != null ? item.original_img_url : null,
                MediumInstruction: item.medium,
                SchedulePreference: item.batch_type,
                StartDate:
                  item.started_dt != null
                    ? moment(item.started_dt).format("YYYY-MM-DD")
                    : "",
                endDate:
                  item.end_dt != null
                    ? moment(item.end_dt).format("YYYY-MM-DD")
                    : "",
                Time: item.start_time,
                endTime: item.end_time,
                pPayment:
                  item.partial_payment && item.partial_payment === 1
                    ? "Yes"
                    : "NO",
                perOne: item.pay_1_perc,
                perTwo: item.pay_2_perc,
                perTwoDate: item.pay_2_duedate
                  ? moment(item.pay_2_duedate, "DD/MM/YYYY").format(
                    "DD/MM/YYYY"
                  )
                  : "",
                perThree: item.pay_3_perc,
                perThreeDate: item.pay_3_duedate
                  ? moment(item.pay_3_duedate, "DD/MM/YYYY").format(
                    "DD/MM/YYYY"
                  )
                  : "",
                Duration: item.duration,
                NoStudents: item.no_of_students,
                NoTest: item.no_of_test,
                subject:
                  item.subject.length > 0
                    ? item.subject.map((el) => el.name).join(", ")
                    : null,
                ask_core_exam: item.ask_core_exam,
                exampassed: item.passed_exam_name,
                subject_file_path:
                  item.subject_file_path != null
                    ? item.subject_file_path
                    : null,
                original_subject_file_path:
                  item.original_subject_file_path != null
                    ? item.original_subject_file_path
                    : null,
                TestPdf: item.test_img_url != null ? item.test_img_url : null,
                original_test_img_url:
                  item.original_test_img_url != null
                    ? item.original_test_img_url
                    : null,
                EnrollStu:
                  res.data.data.batch_students_info.length > 0
                    ? res.data.data.batch_students_info.length
                    : "0",
                Fees: item.fees,
                Discount: item.discount,
                OldsDiscount: item.old_stud_disc,
                OldSBatch: item.old_stud_disc_batch,
                message: item.message,
                location: item.location_name,
                LastDateApply: desiredDateTime.isAfter(currentDateTime)
                  ? true
                  : false,
                // NModelExam: 0,
                NModelExam: item.no_of_modelexam,
              });

              const examCenterDistricts =
                item.district && item.district.length > 0
                  ? item.district.map((center) => ({
                    value: center.district_name,
                    district_id: center.district_id,
                    label: center.district_name,
                    code: center.district_code,
                    centreDetails: center.district_name,
                  }))
                  : [];

              setSelectDistricts(examCenterDistricts);
            }

            // panel members fill
            if (Object.keys(res.data.data.batch_panels).length > 0) {
              if (res.data.data.batch_panels.panel_data.length > 0) {
                const updatedMockPanel = [...mockPanel];
                const updatedCPanel = [...cPanel];
                res.data.data.batch_panels.panel_data.forEach((el, index) => {
                  let panelMem = [];
                  let staffMem = [];
                  let department = [];
                  let CPaneMem = [];
                  let CStaffM = [];
                  if (el.panel_mebers_list.length > 0) {
                    el.panel_mebers_list.map((ko) => {
                      if (ko.type === 3) {
                        // panelMem
                        panelMem.push({
                          staff_id: ko.panel_member_id,
                          name: ko.panel_member_name,
                          type: ko.type,
                          department:
                            ko.department !== ""
                              ? ko.department.split(",")
                              : [],
                        });
                        CPaneMem.push({
                          staff_id: ko.panel_member_id,
                          name: ko.panel_member_name,
                          type: ko.type,
                          department:
                            ko.department !== ""
                              ? ko.department.split(",")
                              : [],
                        });
                        if (ko.department !== "") {
                          const bbd = ko.department.split(",");
                          department.push(bbd);
                        }
                      } else if (ko.type === 0) {
                        //  StaffMem
                        staffMem.push({
                          staff_id: ko.panel_member_id,
                          name: ko.panel_member_name,
                          type: ko.type,
                          department: "",
                        });
                        CStaffM.push({
                          staff_id: ko.panel_member_id,
                          name: ko.panel_member_name,
                          type: ko.type,
                          department: "",
                        });
                      }
                    });
                  }
                  updatedMockPanel[index] = {
                    ...updatedMockPanel[index],
                    id: index + 1,
                    panel_name: el.panel_name, // Update other properties as needed
                    available_dates: el.available_dates,
                    panelMem,
                    staffMem,
                    error_1: "",
                    error_2: "",
                    error_3: "",
                    error_4: "",
                    error_5: "",
                  };

                  updatedCPanel[index] = {
                    ...updatedCPanel[index],
                    id: index + 1,
                    panel_name: el.panel_name, // Update other properties as needed
                    date: el.available_dates,
                    department,
                    StartTime: el.start_time,
                    EndTime: el.end_time,
                    CPaneMem,
                    CStaffM,
                    error_1: "",
                    error_2: "",
                    error_3: "",
                    error_4: "",
                    error_5: "",
                    error_6: "",
                    error_7: "",
                    error_8: "",
                  };
                });
                setMockPanel(updatedMockPanel);
                setCPanel(updatedCPanel);
              }
            }

            // model exam special offer
            if (res.data.data.spc_offer.length > 0) {
              const speciModel = res.data.data.spc_offer.map((vb, index) => {
                let vhui = "";
                if (vb.discount_type === 0) {
                  vhui = "1";
                } else if (vb.discount_type === 1) {
                  vhui = "2";
                } else if (vb.discount_type === 2) {
                  vhui = "3";
                } else if (vb.discount_type === 3) {
                  vhui = "4";
                }

                const bhu =
                  vb.applicable_batches && vb.applicable_batches.length > 0
                    ? vb.applicable_batches.map((el) => ({
                      id: el.id,
                      label: el.batch_name,
                      value: el.id,
                    }))
                    : [];

                return {
                  id: index + 1,
                  pk: vb.id,
                  NoStudentBatch: vhui,
                  SOfferDis: vb.offer_perc,
                  selectedOptions: bhu,
                  ApplicableBatch: [],
                  MEABatch: "",
                  StudentBatchCount: vb.stud_count,
                  error_1: "",
                  error_2: "",
                  error_3: "",
                  error_4: "",
                };
              });
              setMExamSF(speciModel);
            }

            if (Object.keys(res.data.data.batch_panels).length > 0) {
              if (res.data.data.batch_panels.exam_fees.length > 0) {
                res.data.data.batch_panels.exam_fees.map((el, index) => {
                  setMockPanel((prevState) =>
                    prevState.map((q) => {
                      if (q.id === el.fees_count) {
                        return { ...q, fees: el.fees }; // Update the fees property
                      }
                      return q;
                    })
                  );
                  setCPanel((prevState) =>
                    prevState.map((q) => {
                      if (q.id === el.fees_count) {
                        return { ...q, fees: el.fees }; // Update the fees property
                      }
                      return q;
                    })
                  );
                });
              }
            }

            if (res.data.data.batch_old_student_discount.length > 0) {
              const promises = res.data.data.batch_old_student_discount.map(
                (obj) => getOldBatchView(obj.batch_start, obj.batch_end)
              );
              Promise.all(promises)
                .then((results) => {
                  let idCounter = 1; // Initialize the ID counter
                  const result = Object.values(
                    res.data.data.batch_old_student_discount.reduce(
                      (acc, obj, index) => {
                        const BacthList = results[index].map((item) => ({
                          value: item.category_class,
                          label: item.category_class,
                          is_disabled: false,
                          category: item.category,
                        }));

                        if (!acc[obj.pk]) {
                          acc[obj.pk] = {
                            id: idCounter,
                            OldDPercentage: obj.old_stud_disc,
                            BatchRFrom: moment(obj.batch_start).format(
                              "YYYY-MM-DD"
                            ),
                            BatchRTo: moment(obj.batch_end).format(
                              "YYYY-MM-DD"
                            ),
                            selectedOptions: [],
                            ApplicableBatch: [],
                          };
                          idCounter++; // Increment the ID counter
                        }

                        acc[obj.pk].ApplicableBatch = BacthList;
                        const applicableBatches =
                          obj.applicable_batches !== null
                            ? obj.applicable_batches.split(",")
                            : [];
                        acc[obj.pk].selectedOptions = applicableBatches.map(
                          (batch) => ({
                            value: batch.trim(),
                            label: batch.trim(),
                          })
                        );
                        return acc;
                      },
                      {}
                    )
                  );
                  setOldBatch(result);
                })
                .catch((error) => {
                  console.error(error);
                });
            }

            if (res.data.data.batch_exam_center.length > 0) {
              // console.log("res.data.data.batch_exam_center ", res.data.data.batch_exam_center);
              
              const examCenterDistrict = res.data.data.batch_exam_center.map(
                (center) => ({
                  value: center.exam_center_district,
                  district_id: center.district_id,
                  label: center.exam_center_district,
                  code: center.exam_district_code,
                  centreDetails: center.exam_center_name,
                  enroll_count: center.enroll_count,
                })
              );

              setSelectDistrict(examCenterDistrict);

              const result = res.data.data.batch_exam_center.map(
                (obj, index) => {
                  const id = index + 1;
                  const bbb = {
                    id: id,
                    pk: obj.pk,
                    error_1: "",
                    error_2: "",
                    district_id: obj.district_id,
                    districtCode: obj.exam_district_code,
                    district: {
                      value: obj.district_id,
                      district_id: obj.district_id,
                      label: obj.exam_center_district,
                    },
                    enroll_count:
                      obj.enroll_count.length > 0 ? obj.enroll_count : [],
                    examCenter: obj.exam_center_name.map((elo) => ({
                      examCenter_id: obj.id,
                      pk: elo.pk,
                      examCenterOption: [],
                      exam_center:
                        elo.name !== null && elo.name !== "null"
                          ? elo.name
                          : "", // Populate exam_center if exam_center_name is not null
                      MaxCount: elo.max_count,
                      staff_id: elo.staff_id,
                      redwnld_req_approved: elo.redwnld_req_approved,
                      full_name: elo.full_name,
                      mobile_no: elo.mobile_no,
                      locationUrl:
                        elo.location_url !== null || elo.location_url !== "null"
                          ? elo.location_url
                          : "",
                      enroll_count:
                        elo.enroll_count.length > 0 ? elo.enroll_count : [],
                      error_3: "",
                      error_4: "",
                      error_5: "",
                    })),
                  };
                  return bbb;
                },
                {}
              );

              const districtWiseData = Object.values(result); // Convert object to array
              setDistrictWise(districtWiseData);
            }
            if (Object.keys(res.data.data.batch_exam_details).length > 0) {
              if (res.data.data.batch_exam_details.exam_fees.length > 0) {
                const slab_details =
                  res.data.data.batch_exam_details.exam_fees.map(
                    (el, index) => {
                      return {
                        pk: el.batch_id,
                        fees: el.fees,
                        fees_count: el.fees_count,
                      };
                    }
                  );
                setFeesDetails(slab_details);
              }
            }
            if (
              res?.data?.data?.batch_exam_details &&
              Object.keys(res.data.data.batch_exam_details || {}).length > 0
            ) {
              const examDetails =
                res.data.data.batch_exam_details?.exam_details || [];

              if (Array.isArray(examDetails) && examDetails.length > 0) {
                const slab_details = (res.data.data.slab_details || []).map(
                  (el, index) => {
                    return {
                      pk: el?.id ?? "",
                      name: el?.name ?? "",
                      mark: el?.mark ?? "",
                      min_mark: el?.min_mark ?? "",
                      max_mark: el?.max_mark ?? "",
                      slab_count: el?.slab_count ?? "",
                    };
                  }
                );
                setSlabDetails(slab_details);

                const interview_Details = examDetails
                  ?.sort(
                    (a, b) =>
                      parseInt(a?.exam_title_id ?? 0) -
                      parseInt(b?.exam_title_id ?? 0)
                  )
                  ?.map((el, index) => {
                    return {
                      id: index + 1,
                      exam_title_id: el?.exam_title_id ?? "",
                      pk: el?.pk ?? "",
                      title: el?.exam_title ?? "",
                      exam_count: el.exam_count ?? "",
                      date:
                        el?.started_dt !== null && el?.started_dt !== undefined
                          ? moment(el.started_dt).format("DD/MM/YYYY")
                          : "",
                      duration: el?.duration
                        ? convertSecondsToTime(el.duration)
                        : "",
                      startTime: el?.start_time ?? "",
                      endTime: el?.end_time ?? "",
                      syllabus_url: el?.syllabus_url ?? "",
                      original_syllabus_url: el?.original_syllabus_url ?? "",
                      LastDateApply: el?.last_dt_apply ?? "",
                      hall_ticket_status: el?.hall_ticket_status ?? "",
                      NPapers: el?.no_of_paper ?? "",
                      student_count: el?.student_count ?? "",
                      result_status: el?.result_status ?? "",
                      fees: "",
                      error_1: "",
                      error_2: "",
                      error_3: "",
                      error_4: "",
                      error_5: "",
                      error_6: "",
                      error_7: "",
                      error_8: "",
                      error_9: "",
                    };
                  });

                setIntervioewDetails(interview_Details || []);
              }
            }

            if (Object.keys(res.data.data.batch_exam_details).length > 0) {
              if (res.data.data.batch_exam_details.exam_details.length > 0) {
                const filteredData = res.data.data.batch_exam_details.exam_details.filter((item) =>
                  moment(item.last_dt_apply, "DD-MM-YYYY").isSameOrAfter(moment(), "day")
                );
                if(filteredData.length>0){
                  setModelExamRecentObj(moment(filteredData[0].last_dt_apply,"DD-MM-YYYY"));
                }else{
                  setModelExamRecentObj(null);
                }
                
                const sssss = res.data.data.batch_exam_details.exam_details
                  ?.sort(
                    (a, b) =>
                      parseInt(a.exam_title_id) - parseInt(b.exam_title_id)
                  )
                  ?.map((el, index) => {
                    return {
                      id: index + 1,
                      exam_title_id: el.exam_title_id,
                      pk: el.pk,
                      title: el.exam_title,
                      date:
                        el.started_dt !== null
                          ? moment(el.started_dt).format("DD/MM/YYYY")
                          : "",
                      duration: convertSecondsToTime(el.duration),
                      startTime: el.start_time,
                      endTime: el.end_time,
                      syllabus: el.syllabus_url,
                      original_syllabus_url: el.original_syllabus_url,
                      LastDateApply: el.last_dt_apply,
                      hall_ticket_status: el.hall_ticket_status,
                      NPapers: el.no_of_paper,
                      student_count: el.student_count,
                      PaperDetailsSection:
                        el.paper_detail.length > 0
                          ? el.paper_detail
                            ?.sort(
                              (a, b) =>
                                parseInt(a.paper_id) - parseInt(b.paper_id)
                            )
                            ?.map((elll, inf) => ({
                              id: inf + 1,
                              pk: elll.paper_id,
                              title: elll.paper_title,
                              date: elll.start_dt
                                ? moment(elll.start_dt).format("DD/MM/YYYY")
                                : "", //New Changes
                              duration: convertSecondsToTime(elll.duration),
                              startTime: elll.start_time,
                              endTime: elll.end_time,
                              syllabus: elll.syllabus_path,
                              original_syllabus_url:
                                elll.original_syllabus_filename,
                              error_1: "",
                              error_2: "",
                              error_3: "",
                              error_4: "",
                              error_5: "",
                              error_6: "",
                              error_7: "",
                            }))
                          : [
                            {
                              id: 1,
                              title: "",
                              date: "",
                              duration: "",
                              startTime: "",
                              endTime: "",
                              syllabus: null,
                              original_syllabus_url: null,
                              error_1: "",
                              error_2: "",
                              error_3: "",
                              error_4: "",
                              error_5: "",
                              error_6: "",
                              error_7: "",
                            },
                          ],
                      fees: "",
                      error_1: "",
                      error_2: "",
                      error_3: "",
                      error_4: "",
                      error_5: "",
                      error_6: "",
                      error_7: "",
                      error_8: "",
                      error_9: "",
                    };
                  })
                  .sort((a, b) =>
                    moment(a.LastDateApply, "DD-MM-YYYY").diff(
                      moment(b.LastDateApply, "DD-MM-YYYY")
                    )
                  );
                setExamDetails(sssss);
              }
            }

            if (Object.keys(res.data.data.batch_exam_details).length > 0) {
              res.data.data.batch_exam_details.exam_fees.map((el, index) => {
                setExamDetails((prevState) => {
                  const updatedState = prevState.map((q) => {
                    if (q.id === el.fees_count) {
                      return { ...q, fees: el.fees }; // Update the fees property
                    }
                    return q;
                  });
                  const sortedState = updatedState.sort(
                    (a, b) => a.fees_count - b.fees_count
                  );

                  return sortedState;
                });
              });
            }

            if (res.data.data.model_exam_com.length > 0) {
              const model_exam_combination = res.data.data.model_exam_com;
              model_exam_combination.sort((a, b) =>
                a.name.localeCompare(b.name)
              );
              setExamWiseEnroll(model_exam_combination);
            }
            // loadListdata();
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          return error;
        });
    } else {
      console.log("Batch id is missing");
    }
  };
  const [eventFields, setEventFields] = useState([]);
  // List data load table

  // use state
  let page = R_PER_PAGE;

  // use state
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  // const [downloadCSV, setDownloadCSV] = useState([]);
  // const [downloadPDF, setDownloadPDF] = useState([]);
  const [updateListData, setUpdateListData] = useState(listData);
  const [updateChipData, setUpdateChipData] = useState([]);
  const [isOpen, setIsOpen] = useState({
    mode: false,
    gender: false,
    exam_district: false,
    balance_amt: false,
    mediums: false,
    appliedOn: false,
    medium_studied: false,
    core_subject: false,
  });
  const defaultDateFilter = {
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  };
  const [appDatas, setAppDatas] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [appOns, setAppOns] = useState([]);
  const [dexamD, setDexamD] = useState([]);
  const csvLinkRef = useRef(null);
  const [slabDetails, setSlabDetails] = useState([
    {
      mark: "",
      name: "",
      min_mark: "",
      max_mark: "",
      slab_count: "",
      error_1: "",
      error_2: "",
      error_3: "",
      error_4: "",
      error_5: "",
      error_6: "",
      error_7: "",
    },
  ]);
  const sortedSlabDetails = [...slabDetails].sort(
    (a, b) => a.slab_count - b.slab_count
  );
  const [feesDetails, setFeesDetails] = useState([
    {
      id: "",
      fees: "",
      fees_count: "",
    },
  ]);
  const [interviewDetail, setIntervioewDetails] = useState([
    {
      id: 1,
      title: "",
      exam_count: "",
      exam_title_id: "",
      pk: "",
      date: "",
      duration: "",
      startTime: "",
      endTime: "",
      syllabus: null,
      original_syllabus_url: null,
      hall_ticket_status: "",
      result_status: "",
      LastDateApply: "",
      student_count: "",
      PaperDetailsSection: [],
      fees: "",
    },
  ]);

  const [examDetail, setExamDetails] = useState([
    {
      id: 1,
      title: "",
      exam_title_id: "",
      pk: "",
      date: "",
      duration: "",
      startTime: "",
      endTime: "",
      syllabus: null,
      original_syllabus_url: null,
      hall_ticket_status: "",
      LastDateApply: "",
      NPapers: "",
      student_count: "",
      PaperDetailsSection: [],
      fees: "",
      error_1: "",
      error_2: "",
      error_3: "",
      error_4: "",
      error_5: "",
      error_6: "",
      error_7: "",
    },
  ]);

  const [swalMsg, setSwalMsg] = useState({
    show: false,
    status: "",
    message: "",
    title: "",
    BottomOkBtn: "",
    BottomCancelBtn: "",
    BottomOkClose: "",
  });

  const [districtWise, setDistrictWise] = useState([]);
  //   {
  //     id: 1,
  //     pk: "",
  //     district: "",
  //     districtCode: "",
  //     enroll_count: [],
  //     examCenter: [
  //       {
  //         ExamCenter_id: 1,
  //         examCenterOption: [],
  //         exam_center: "",
  //         MaxCount: 0,
  //         locationUrl: "",
  //         enroll_count: [],
  //         error_3: "",
  //         error_4: "",
  //         error_5: "",
  //       },
  //     ],
  //     error_1: "",
  //     error_2: "",
  //   },
  // ]);
  const [oldBatch, setOldBatch] = useState([
    {
      id: 1,
      OldDPercentage: "",
      BatchRFrom: "",
      BatchRTo: "",
      selectedOptions: [],
      ApplicableBatch: [],
    },
  ]);

  const [paymentMode, setPaymentMode] = useState([]);
  const [mode, setMode] = useState([]);
  const [gender, setGender] = useState([]);
  const [exam_district, setExam_district] = useState([]);
  let filterSearch = [];
  let filterMode = [];
  let filterGender = [];
  let filterMedium = [];
  let filterexamD = [];
  let filterPaymentMode = [];
  let filterCoreSubject = [];
  let filterInterviewCount = [];
  let filterApplyeds = [];
  const filterMediumStudied = useRef([]);

  const filterPaymentModeRef = useRef(null);
  const filterModeRef = useRef(null);
  const filterGenderRef = useRef(null);
  const filterExamDistrictRef = useRef(null);
  const filterMediumRef = useRef(null);
  const filterCoreSubjectRef = useRef(null);
  const filterInterviewRef = useRef(null);
  const filterAppliedOnRef = useRef(null);
  const filterCreatedDateRef = useRef(null);
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;

      if (
        filterModeRef.current &&
        !filterModeRef.current.contains(event.target)
      ) {
        const hasType = updateChipData.some(
          (chipItem) => chipItem.type?.trim().toLowerCase() === "mode"
        );
        if (hasType) {
          const updatedApplModeOn = updateChipData.filter(
            (chipItem) => chipItem.type === "mode"
          );

          setMode(updatedApplModeOn);
        } else {
          setMode([]);
        }
        setIsOpen((prev) => ({ ...prev, mode: false }));
      }
      if (
        filterMediumRef.current &&
        !filterMediumRef.current.contains(event.target)
      ) {
        const hasMedium = updateChipData.some(
          (chipItem) => chipItem.type === "medium_studied"
        );
        if (hasMedium) {
          const updatedMedium = updateChipData.filter(
            (chipItem) => chipItem.type === "medium_studied"
          );
          setMedium(updatedMedium);
        } else {
          setMedium([]);
        }
        setIsOpen((prev) => ({ ...prev, medium_studied: false }));
      }
      if (
        filterPaymentModeRef.current &&
        !filterPaymentModeRef.current.contains(event.target)
      ) {
        const hasPaymentMode = updateChipData.some((chipItem) => {
          return chipItem.type?.trim().toLowerCase() === "balance_amt";
        });

        if (hasPaymentMode) {
          const updatedPaymentMode = updateChipData.filter(
            (chipItem) => chipItem.type === "balance_amt"
          );
          setPaymentMode(updatedPaymentMode);
        } else {
          setPaymentMode([]);
        }
        setIsOpen((prev) => ({ ...prev, balance_amt: false }));
      }
      if (
        filterGenderRef.current &&
        !filterGenderRef.current.contains(event.target)
      ) {
        const hasType = updateChipData.some(
          (chipItem) => chipItem.type?.trim().toLowerCase() === "gender"
        );
        if (hasType) {
          const updatedApplModeOn = updateChipData.filter(
            (chipItem) => chipItem.type === "gender"
          );
          setGender(updatedApplModeOn);
        } else {
          setGender([]);
        }
        setIsOpen((prev) => ({ ...prev, gender: false }));
      }
      if (
        filterExamDistrictRef.current &&
        !filterExamDistrictRef.current.contains(event.target)
      ) {
        const hasType = updateChipData.some(
          (chipItem) => chipItem.type?.trim().toLowerCase() === "exam_district"
        );
        if (hasType) {
          const updatedApplModeOn = updateChipData.filter(
            (chipItem) => chipItem.type === "exam_district"
          );
          setExam_district(updatedApplModeOn);
        } else {
          setExam_district([]);
        }

        setIsOpen((prev) => ({ ...prev, exam_district: false }));
      }
      // CORE SUBJECT
      if (
        filterCoreSubjectRef.current &&
        !filterCoreSubjectRef.current.contains(event.target)
      ) {
        const hasCore = updateChipData.some(
          (chip) => chip.type === "core_subject"
        );
        setCoreSubjects(
          hasCore ? updateChipData.filter((c) => c.type === "core_subject") : []
        );
        setIsOpen((prev) => ({ ...prev, core_subject: false }));
      }

      // NO OF INTERVIEW
      if (
        filterInterviewRef.current &&
        !filterInterviewRef.current.contains(event.target)
      ) {
        const hasInterview = updateChipData.some(
          (chip) => chip.type === "interview_count"
        );
        setInterviews(
          hasInterview
            ? updateChipData.filter((c) => c.type === "interview_count")
            : []
        );
        setIsOpen((prev) => ({ ...prev, interview_count: false }));
      }
      // Created date
      if (
        filterCreatedDateRef.current &&
        !filterCreatedDateRef.current.contains(event.target)
      ) {
        setIsOpen((prev) => ({ ...prev, appliedOn: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData]);

  useEffect(() => {
    // Get all "Show More" buttons within elements having the class "rbc-today"
    const showMoreButtons = document.querySelectorAll(
      ".rbc-today .rbc-button-link.rbc-show-more"
    );

    // Iterate through the "Show More" buttons within "rbc-today" and add the class
    showMoreButtons.forEach((element) => {
      element.classList.add("rbc_show_more_today");
    });
  }, []);

  useEffect(() => {
    filterMode = mode ? mode : [];
  }, [mode]);

  useEffect(() => {
    filterGender = gender;
  }, [gender]);
  useEffect(() => {
    filterMedium = mediums;
  }, [mediums]);
  // useEffect(() => {
  //   filterMediumStudied.current = mediums;
  // }, [mediums]);

  useEffect(() => {
    filterexamD = exam_district;
  }, [exam_district]);

  useEffect(() => {
    filterApplyeds = appOns;
  }, [appDatas]);

  useEffect(() => {
    if (searchTerm?.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);

  useEffect(() => {
    if (MODE && MODE?.length > 0) {
      setMode(MODE ? MODE : []);
      filterMode = MODE ? MODE : [];
      loadChipdata();
    } else {
      setMode(mode ? MODE : []);
      filterMode = mode ? MODE : [];
    }
  }, []);

  useEffect(() => {
    if (GENDER && GENDER?.length > 0) {
      setGender(GENDER ? GENDER : []);
      filterGender = GENDER ? GENDER : [];
      loadChipdata();
    } else {
      setGender(gender ? GENDER : []);
      filterGender = gender ? GENDER : [];
    }
  }, []);

  useEffect(() => {
    if (CORESUBJECT && CORESUBJECT?.length > 0) {
      setCoreSubjects(CORESUBJECT ? CORESUBJECT : []);
      filterCoreSubject = CORESUBJECT ? CORESUBJECT : [];
      loadChipdata();
    } else {
      setCoreSubjects(coreSubjects ? CORESUBJECT : []);
      filterCoreSubject = coreSubjects ? CORESUBJECT : [];
    }
  }, []);

  useEffect(() => {
    const hasDateFilters = Array.isArray(DATEFILTERS) && DATEFILTERS.length > 0;

    if (hasDateFilters) {
      setAppDatas({
        FDate: DATEFILTERS[0].fdate,
        TDate: DATEFILTERS[0].edate,
        Days: DATEFILTERS[0].Days || "",
        name: DATEFILTERS[0].name || "",
      });

      setAppOns(DATEFILTERS);
      filterApplyeds = DATEFILTERS;

      loadChipdata();
    } else {
      setAppDatas(defaultDateFilter);
      setAppOns([]);
      filterApplyeds = [];
    }
  }, [DATEFILTERS]);

  // useEffect(() => {
  //   if (MEDIUMSTUDIED && MEDIUMSTUDIED?.length > 0) {
  //     setMedium(MEDIUMSTUDIED ? MEDIUMSTUDIED : []);
  //     filterMediumStudied.current = MEDIUMSTUDIED ? MEDIUMSTUDIED : [];
  //     loadChipdata();
  //   } else {
  //     setMedium(mediums ? MEDIUMSTUDIED : []);
  //     filterMediumStudied.current = mediums ? MEDIUMSTUDIED : [];
  //   }
  // }, []);
  useEffect(() => {
    if (MEDIUMSTUDIED && MEDIUMSTUDIED?.length > 0) {
      setMedium(MEDIUMSTUDIED ? MEDIUMSTUDIED : []);
      filterMedium = MEDIUMSTUDIED ? MEDIUMSTUDIED : [];
      loadChipdata();
    } else {
      setMedium(exam_district ? MEDIUMSTUDIED : []);
      filterMedium = exam_district ? MEDIUMSTUDIED : [];
    }
  }, []);
  useEffect(() => {
    if (EXAMDISTRICT && EXAMDISTRICT?.length > 0) {
      setExam_district(EXAMDISTRICT ? EXAMDISTRICT : []);
      filterexamD = EXAMDISTRICT ? EXAMDISTRICT : [];
      loadChipdata();
    } else {
      setExam_district(exam_district ? EXAMDISTRICT : []);
      filterexamD = exam_district ? EXAMDISTRICT : [];
    }
  }, []);

  const handleGenerateCallLetter = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (PAYMENTMODE && PAYMENTMODE?.length > 0) {
      setPaymentMode(PAYMENTMODE ? PAYMENTMODE : []);
      filterPaymentMode = PAYMENTMODE ? PAYMENTMODE : [];
      loadChipdata();
    } else {
      setPaymentMode(paymentMode ? PAYMENTMODE : []);
      filterPaymentMode = paymentMode ? PAYMENTMODE : [];
    }
  }, []);

  useEffect(() => {
    if (SEARCHTERM && SEARCHTERM?.length > 0) {
      setSearchTerm(SEARCHTERM);
      filterSearch = [{ name: "" + SEARCHTERM, type: "search" }];
      loadChipdata();
    } else {
      if (searchTerm && searchTerm?.length > 0) {
        setSearchTerm(searchTerm);
        filterSearch = [{ name: "" + searchTerm, type: "search" }];
      }
    }
  }, []);

  useEffect(() => {
    loadChipdata();
  }, []);

  useEffect(() => {
    loadListdata();
  }, [updateChipData]);

  useEffect(() => {
    if (csvLinkRef.current && csvListData.length > 0) {
      csvLinkRef.current.link.click();
    }
  }, [csvListData]);

  useEffect(() => {
    setSearchTerm(SEARCHTERM);
    setMode(MODE ? MODE : []);
    setGender(GENDER ? GENDER : []);
    setCoreSubjects(CORESUBJECT ? CORESUBJECT : []);
    // setAppDatas(DATEFILTERS ? DATEFILTERS : [defaultDateFilter]);
    setMedium(MEDIUMSTUDIED ? MEDIUMSTUDIED : []);
    setExam_district(EXAMDISTRICT ? EXAMDISTRICT : []);
    setPaymentMode(PAYMENTMODE ? PAYMENTMODE : []);
    // setUpdateChipData(tempArr);
  }, [
    MODE,
    GENDER,
    EXAMDISTRICT,
    SEARCHTERM,
    PAYMENTMODE,
    CORESUBJECT,
    DATEFILTERS,
  ]);

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    // setSortColumn(sortKey);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
    setSortColumn(sortKey);
  };

  const handleFilterCourseSearch = (event) => {
    const searchInput = event.target.value;

    if (searchInput !== "") {
      const matchingObjects = dexamD.filter(
        (item) =>
          item.label &&
          item.label.toLowerCase().includes(searchInput.toLowerCase())
      );
      // Do something with the matchingObjects, such as updating state or displaying them in the UI
      setDexamD(matchingObjects);
    } else {
      setDexamD(dexamD);
    }
  };
  // filter clear button
  const handleClear = (name) => {
    updateStateData();
    if (name === "mode") {
      setMode([]);
      filterMode = [];
    } else if (name === "gender") {
      setGender([]);
      filterGender = [];
    } else if (name === "exam_district") {
      setExam_district([]);
      filterexamD = [];
    } else if (name === "balance_amt") {
      setPaymentMode([]);
      filterPaymentMode = [];
    } else if (name === "core_subject") {
      setCoreSubjects([]);
      filterCoreSubject = [];
    } else if (name === "interview_count") {
      setInterviews([]);
      filterInterviewCount = [];
    } else if (name === "medium_studied") {
      setMedium([]);
      filterMedium = [];
      // filterMediumStudied.current = [];
    } else if (name === "appliedOn") {
      setAppDatas(defaultDateFilter);
      setAppOns([]);
      filterApplyeds = [];
    }

    setIsOpen({
      mode: false,
      gender: false,
      exam_district: false,
      balance_amt: false,
      medium_studied: false,
      appliedOn: false,
    });
    loadChipdata();
  };

  //chips overall clear button
  const handleAllClear = () => {
    setIsOpen({
      mode: false,
      gender: false,
      exam_district: false,
      balance_amt: false,
      mediums: false,
      appliedOn: false,
      medium_studied: false,
      core_subject: false,
    });
    setAppDatas(defaultDateFilter);
    setAppOns([]);
    setSearchTerm("");
    setMode([]);
    setGender([]);
    setCoreSubjects([]);
    setMedium([]);
    setExam_district([]);
    setPaymentMode([]);
    loadChipdata();

    // Reset location state by navigating to the same route without state
    navigate(location.pathname, { replace: true, state: null });
  };

  // const getExamCenterView = (value) => {
  //   return AxiosInstance.post("api/examcenter/name", { district: value })
  //     .then((res) => res.data.data)
  //     .catch((error) => {
  //       console.error(error);
  //       return [];
  //     });
  // };

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (name === "Classroom" || name === "Online") {
      if (checked) {
        setMode([{ id: value, name: name, type: "mode" }]);
      } else {
        setMode(mode?.filter((item) => item.id !== value));
      }
    } else if (name === "English" || name === "Tamil") {
      if (checked) {
        setMedium([{ id: value, name: name, type: "medium_studied" }]);
      } else {
        setMedium(mediums.filter((item) => item.id !== value));
      }
    } else if (
      names === "male" ||
      names === "female" ||
      names === "transgender"
    ) {
      if (checked) {
        setGender([...gender, { id: value, name: name, type: "gender" }]);
      } else {
        setGender(gender?.filter((item) => item.id !== value));
      }
    } else if (names === "exam_district") {
      if (checked) {
        setExam_district([
          ...exam_district,
          { id: value, name: name, type: "exam_district" },
        ]);
      } else {
        setExam_district(exam_district.filter((item) => item.id !== value));
      }
    } else if (names === "core_subject") {
      setCoreSubjects((prev) => {
        const exists = prev.some((item) => item.id === value);

        if (exists) {
          // remove if already exists
          return prev.filter((item) => item.id !== value);
        } else {
          // add if not exists
          return [
            ...prev,
            {
              id: value,
              name: name || "",
              type: "core_subject",
            },
          ];
        }
      });
    } else if (names === "interview_count") {
      if (checked) {
        setInterviews([{ id: value, name, type: "interview_count" }]);
      } else {
        setInterviews([]);
      }
    }

    if (names === "balance_amt") {
      if (checked) {
        setPaymentMode((prev) => [
          { id: value, name: name, type: "balance_amt" },
        ]);
      } else {
        setPaymentMode((prev) =>
          prev.filter(
            (item) => item.id !== value || item.type !== "balance_amt"
          )
        );
      }
    }
  };

  async function getOldBatchView(fTime, Ttime) {
    const dats = {
      start_date: fTime,
      end_date: Ttime,
    };

    try {
      const response = await AxiosInstance.post("api/batch/oldStud/list", dats);
      if (response.data.data.length > 0) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  // useEffect(() => {
  //   const navEntries = performance.getEntriesByType("navigation");
  //   const isReload =
  //     navEntries.length > 0 &&
  //     navEntries[0].type === "reload";

  //   if (isReload && location.state) {
  //     navigate(location.pathname, { replace: true, state: null });
  //   }

  // }, [location, navigate]);

  const handleDelete = (chipToDelete, index) => () => {
    console.log("chipToDelete", chipToDelete);

    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "mode") {
      const updatedMode = mode.filter((item) => item.id !== chipToDelete.id);
      setMode(updatedMode);
      filterMode = updatedMode;
    } else if (chipToDelete.type === "gender") {
      const updatedGender = gender.filter(
        (item) => item.id !== chipToDelete.id
      );
      setGender(updatedGender);
      filterGender = updatedGender;
    } else if (chipToDelete.type === "exam_district") {
      const updatedExamDistrict = exam_district.filter(
        (item) => item.id !== chipToDelete.id
      );
      setExam_district(updatedExamDistrict);
      filterexamD = updatedExamDistrict;
    } else if (chipToDelete.type === "balance_amt") {
      const updatedPaymentMode = paymentMode.filter(
        (item) => item.id !== chipToDelete.id
      );
      setPaymentMode(updatedPaymentMode);
      filterPaymentMode = updatedPaymentMode;
    } else if (chipToDelete.type === "core_subject") {
      const updatedCoreSubject = coreSubjects.filter(
        (item) => item.id !== chipToDelete.id
      );
      setCoreSubjects(updatedCoreSubject);
      filterCoreSubject = updatedCoreSubject;
    } else if (chipToDelete.type === "medium_studied") {
      const updatedMedium = mediums.filter(
        (item) => item.id !== chipToDelete.id
      );
      setMedium(updatedMedium);
      filterGender = updatedMedium;
    } else if (chipToDelete.type === "created_dt") {
      //  Clear DatePicker inputs
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });

      //  Clear applied date chips
      setAppOns([]);
      filterApplyeds = [];

      //  Remove chip from UI
      setUpdateChipData((prev) => prev.filter((e) => e.type !== "created_dt"));

      // Reload data without date filter
      loadListdata();

      return;
    }

    loadChipdata();
  };

  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "mode") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        mode: false,
      });
    } else if (name === "gender") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        gender: false,
      });
    } else if (name === "exam_district") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        exam_district: false,
      });
    } else if (name === "balance_amt") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        balance_amt: false,
      });
    } else if (name === "medium_studied") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        medium_studied: false,
      });
    } else if (name === "core_subject") {
      loadChipdata();
      setIsOpen({ ...isOpen, core_subject: false });
    } else if (name === "interview_count") {
      loadChipdata();
      setIsOpen({ ...isOpen, interview_count: false });
    }
    if (name === "appliedOn") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        appliedOn: false,
      });
    }
  };

  // handle search function
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      // 👇 Get input value
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };

  // --------New code (Search Icon)----
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };

  function updateStateData() {
    filterGender = gender;
    filterMode = mode;
    filterexamD = exam_district;
    filterPaymentMode = paymentMode;
    filterCoreSubject = coreSubjects;
    filterInterviewCount = interviews;
    if (searchTerm?.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  function loadListdata() {
    let tempMode = [];
    let tempGender = [];
    let tempDistrict = [];
    let tempMedium = "";

    // class mode
    mode?.forEach((obj) => tempMode.push(obj.name));

    // gender
    gender?.forEach((obj) => tempGender.push(obj.name));

    // district
    exam_district?.forEach((obj) => tempDistrict.push(Number(obj.id)));

    // medium studied (single select expected)
    if (mediums?.length > 0) {
      tempMedium = mediums[0]?.name; // "Tamil" | "English"
    }

    const statusFilter = {
      id: id,
      class_mode: tempMode.length ? tempMode : "",
      gender: tempGender.length ? tempGender : "",
      district: tempDistrict.length ? tempDistrict : "",
      search: searchTerm?.length ? searchTerm : "",
      is_balance: paymentMode?.length ? Number(paymentMode[0]?.id) : "",
      core_subject: coreSubjects?.length ? coreSubjects.map((o) => o.name) : "",
      medium_studied: tempMedium,
      interview_count: interviews?.length ? Number(interviews[0].id) : "",
      start_date: appDatas?.FDate
        ? moment(appDatas.FDate).format("YYYY-MM-DD")
        : "",
      end_date: appDatas?.TDate
        ? moment(appDatas.TDate).format("YYYY-MM-DD")
        : "",
    };

    AxiosInstance.post("api/batch/studentlist/byFilter", statusFilter)
      .then((res) => {
        if (res.data.status === true) {
          const serialNumberAddedData = res.data.data.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setCurrentPage(1);
          setUpdateListData(serialNumberAddedData);
          if (type === "5") {
            const coreSubjects = res?.data?.data
              .map((item) => item.core_subject)
              .filter(
                (subject) =>
                  subject !== null &&
                  subject !== undefined &&
                  subject.trim() !== ""
              );
            // Remove duplicates
            const uniqueSubjects = [...new Set(coreSubjects)];

            // Convert to dropdown format
            const coreSubjectOptions = uniqueSubjects.map((subject) => ({
              value: subject,
              label: subject,
            }));

            setCoreSubjectsOptions(coreSubjectOptions);
          }
        } else {
          setUpdateListData([]);
        }
      })
      .catch(() => setUpdateListData([]));
  }

  function loadChipdata() {
    //setUpdateChipData([]);
    let tempArr = [];
    // setUpdateChipData(status);
    filterSearch?.map((obj) => {
      tempArr.push(obj);
    });

    filterMode?.map((obj) => {
      tempArr.push(obj);
    });
    filterGender?.map((obj) => {
      tempArr.push(obj);
    });
    filterexamD?.map((obj) => {
      tempArr.push(obj);
    });
    filterPaymentMode?.map((obj) => {
      tempArr.push(obj);
    });
    filterMedium?.map((obj) => {
      tempArr.push(obj);
    });
    // filterMediumStudied.current?.map((obj) => tempArr.push(obj));

    filterApplyeds?.map((obj) => {
      tempArr.push(obj);
    });
    filterCoreSubject?.forEach((o) => tempArr.push(o));
    filterInterviewCount?.forEach((o) => tempArr.push(o));

    setUpdateChipData(tempArr);
  }

  const handleFilter = (e, dame) => {
    // alert(dame,"dame");
    if (dame === "mode") {
      setIsOpen((prevState) => ({
        ...prevState,
        mode: !prevState.mode,
        gender: false,
        exam_district: false,
      }));
    } else if (dame === "gender") {
      setIsOpen((prevState) => ({
        ...prevState,
        gender: !prevState.gender,
        mode: false,
        exam_district: false,
        core_subject: false,
      }));
    } else if (dame === "exam_district") {
      setIsOpen((prevState) => ({
        ...prevState,
        exam_district: !prevState.exam_district,
        gender: false,
        mode: false,
        core_subject: false,
      }));
    } else if (dame === "balance_amt") {
      setIsOpen((prevState) => ({
        ...prevState,
        balance_amt: !prevState.balance_amt,
        gender: false,
        mode: false,
        exam_district: false,
        core_subject: false,
      }));
    } else if (dame === "core_subject") {
      setIsOpen((prevState) => ({
        ...prevState,
        mode: false,
        gender: false,
        exam_district: false,
        balance_amt: false,
        mediums: false,
        appliedOn: false,
        medium_studied: false,
        core_subject: !prevState.core_subject,
      }));
    } else if (dame === "medium_studied") {
      setIsOpen((prevState) => ({
        ...prevState,
        medium_studied: !prevState.medium_studied,
        gender: false,
        mode: false,
        exam_district: false,
        core_subject: false,
      }));
    } else if (dame === "appliedOn") {
      setIsOpen((prevState) => ({
        ...prevState,
        appliedOn: !prevState.appliedOn,
        gender: false,
        mode: false,
        exam_district: false,
        core_subject: false,
      }));
    }
  };

  // generate pdf when user click download button

  // total table data  with pages
  const totalPages = Math.ceil(updateListData.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  // page count handle
  const handlePageCount = (e) => {
    const { name, value, checked } = e.target;
    if (name === "modelExamList") {
      setRowsPerPage(parseInt(value));
      setCurrentPage(1);
      setUpdateListData([]);
    }
    loadListdata();
  };

  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData.slice(start, end);

  const startedDt = moment.utc(formFields.StartDate);

  // const twelveAMNextDay = startedDt.clone().add(1, "day").startOf("day");

  const handleCoreExam = (id, ask_core_exam) => {
    const ask_core_exam_chn = ask_core_exam === 0 ? 1 : 0;
    const coreExamdat = {
      type: type ? parseInt(type) : 4, //  model exam -> default type as 4
      batch_id: parseInt(id),
      ask_core_exam: ask_core_exam_chn,
    };
    AxiosInstance.post("api/batch/ask/coreExamDet", coreExamdat)
      .then((res) => {
        if (res.data.status === true) {
          FindById();
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const handleOpenHallPopup = () => {
    if (id) {
      AxiosInstance.post("api/batch/generate/hallticketME/view", {
        batch_id: parseInt(id),
      })
        .then((res) => {
          if (res.data.status === true) {
            if (res.data.data && res.data.data.info) {
              const hallTicketInfo =
                res.data.data.info.length > 0 && res.data.data.info;
              let SortHall = "";
              if (hallTicketInfo[0].paper_type === 0) {
                SortHall = hallTicketInfo
                  .filter((item) => new Date(item.started_dt) > currentDate)
                  .sort(
                    (a, b) => new Date(a.started_dt) - new Date(b.started_dt)
                  );
              } else {
                // Extract all start dates with their parent object
                const examDatesWithDetails = hallTicketInfo.flatMap((exam) =>
                  exam.pap_det.map((pap) => ({
                    ...pap,
                    no_of_paper: exam.no_of_paper, // Append the `no_of_paper` property to each `pap_det`
                    hall_ticket_status: exam.hall_ticket_status,
                    exam_detail_cstm_pk: exam.exam_detail_cstm_pk,
                    exam_title: exam.exam_title,
                    last_dt_apply: exam.last_dt_apply,
                  }))
                );
                // Find the earliest start date
                const nearestExamDetail = examDatesWithDetails
                  .filter((item) => new Date(item.start_dt) > currentDate)
                  .reduce((prev, curr) =>
                    prev.start_dt < curr.start_dt ? prev : curr
                  );
                SortHall = [nearestExamDetail];
              }
              setHallTicketData(SortHall);
            } else {
              setHallTicketData([]);
              setIsPaymentLoading(false);
            }
          } else {
            setHallTicketData([]);
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      console.log("BatchID is missing");
    }
    setOpenHallModal(true);
  };

  const handleFailureCase = () => {
    Swal.fire({
      title: "Warning",
      text: "At least one student needs to be enrolled and an exam center needs to be allocated.",
      icon: "Warning",
      confirmButtonText: "Ok",
    });
  };

  const handleHallClose = () => {
    setOpenHallModal(false);
  };

  const handleExamCentreNavigation = () => {
    console.log("Dist data ", selectedDistrict);
    
    const districtData = selectedDistrict.map((dist) => ({
      id: dist.district_id,
      name: dist.label,
      code: dist.code,
      centreDetails: dist.centreDetails,
      enroll_count:dist.enroll_count,
    }));
    const currentDateOnly = moment().startOf("day");
    const examDetailID = examDetail
      .filter((item) =>
        moment(item.LastDateApply, "DD-MM-YYYY").isSameOrAfter(currentDateOnly)
      )
      .sort(
        (a, b) =>
          moment(a.LastDateApply, "DD-MM-YYYY") -
          moment(b.LastDateApply, "DD-MM-YYYY")
      )
      .map((item) => ({
        pk: item.pk,
        exam_title_id: item.exam_title_id,
        title: item.title,
      }));

    const vb = examDetailID.find((bh) => bh.exam_title_id === 1)
      ? examDetailID.filter((bh) => bh.exam_title_id !== 1)
      : [];

    navigate("/exam_centre", {
      state: {
        districtData,
        batchID: API_BATCH_ID,
        examDetailLID: examDetailID[0].pk,
        examDetailTile: examDetailID[0].title,
        examDetailIDS: vb.length > 0 ? vb.map((er) => er.pk) : [],
      },
    });
  };

  const handleGenReport = () => {
    navigate(`/GenerateReport/${id}`);
  };
  const [open, setOpen] = useState(false);
  const handleCenterSupervisor = () => {
    // setOpen(true);
    navigate(`/CentreSupervisors/${id}`);
  };
  const handleModelClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    setIsPaymentLoading(true);

    AxiosInstance.post("api/mockinterview/interview/generate_now", {
      batch_id: parseInt(id),
      interview_id: latestInterview?.pk,
      interview_date: moment(latestInterview?.date, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      ),
    })

      .then((res) => {
        if (res.data.status === true) {
          setIsPaymentLoading(false);
          setOpen(false);
          FindById();
          Swal.fire({
            title: "Success",
            text: res.data.message,
            icon: "Success",
            confirmButtonText: "Ok",
          });
        } else {
          setIsPaymentLoading(false);
          setOpen(false);
          FindById();
          Swal.fire({
            title: "Warning",
            text: res.data.message,
            icon: "Warning",
            confirmButtonText: "Ok",
          });
        }
      })
      .catch((error) => {
        setIsPaymentLoading(false);
        setOpen(false);
        FindById();
        return error;
      });
  };

  const referenceDate = moment();
  const latestInterview = interviewDetail
    ?.map((item) => ({
      ...item,
      parsedDate: moment(item.date, "DD/MM/YYYY"),
    }))
    .filter(
      (item) =>
        item.parsedDate.isAfter(referenceDate) && item.hall_ticket_status === 0 // ⭐ ADD THIS FILTER - only interviews without call letter
    )
    .sort((a, b) => a.parsedDate - b.parsedDate)[0]; // Get the earliest one

  // Find the NEXT interview that NEEDS call letter generation
  const nextInterviewForCallLetter = interviewDetail
    ?.map((item) => ({
      ...item,
      parsedDate: moment(item.date, "DD/MM/YYYY"),
    }))
    .filter(
      (item) =>
        item.parsedDate.isAfter(referenceDate) && item.hall_ticket_status === 0 // ⭐ ADD THIS FILTER - only interviews without call letter
    )
    .sort((a, b) => a.parsedDate - b.parsedDate)[0]; // Get the earliest one

  const isWithinTwoDaysBeforeInterview = (interviewDateStr) => {
    if (!interviewDateStr) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const interviewDate = new Date(
      interviewDateStr.split("/").reverse().join("-")
    );
    interviewDate.setHours(0, 0, 0, 0);

    const diffInDays = Math.floor(
      (interviewDate - today) / (1000 * 60 * 60 * 24)
    );

    // Enable ONLY when diff is 1 or 2 (1 day before or 2 days before)
    return diffInDays === 1 || diffInDays === 2;
  };

  const hasBatchStudents = Array.isArray(listData) && listData.length > 0;

  const isGenerateDisabled =
    // Condition 0: No interview needs call letter generation
    !nextInterviewForCallLetter ||
    // Condition 1: Not within allowed interview date window
    !isWithinTwoDaysBeforeInterview(nextInterviewForCallLetter?.date) ||
    // Condition 2: No students in batch
    !hasBatchStudents;

  const handleInterview = () => {
    // navigate("/CentreSupervisors");
    navigate(`/ListInterviewDetails/${id}`, {
      state: {
        BATCHID: id,
        TYPE: 5,
      },
    });
  };
  const handleAttenClose = () => {
    setOpenAttenModal(false);
  };

  const handleMainHallThicket = (exam_title_idd) => {
    if (exam_title_idd) {
      setIsPaymentLoading(true);
      AxiosInstance.post("api/batch/generate/hallticket/info", {
        batch_id: parseInt(id),
        exam_detail_id: exam_title_idd,
        type: 4,
        created_by: userid,
        updated_by: userid,
      })
        .then((res) => {
          if (res.data.status === true) {
            setIsPaymentLoading(false);
            Swal.fire({
              title: "Success",
              text: res.data.message,
              icon: "Success",
              confirmButtonText: "Ok",
            });
            FindById();
            handleHallClose();
          } else {
            setIsPaymentLoading(false);
            Swal.fire({
              title: "Warning",
              text: res.data.message,
              icon: "Warning",
              confirmButtonText: "Ok",
            });
            handleHallClose();
          }
        })
        .catch((error) => {
          setIsPaymentLoading(false);
          return error;
        });
    } else {
      console.log("exam_title_idd is missing");
    }
  };

  // Function to convert an array of objects into CSV format
  const convertToCSV = (data) => {
    // Extract the headers from the keys of the first object
    const headers = Object.keys(data[0]).join(",");

    // Create CSV rows by joining values with commas
    const rows = data.map((obj) => {
      return Object.values(obj)
        .map((val) => `"${val}"`)
        .join(",");
    });

    // Combine the headers and rows into a single CSV string
    const csvContent = [headers, ...rows].join("\n");

    return csvContent;
  };

  // Function to trigger a CSV download
  const downloadCSV = (csvContent, filename = "AttendenceSheet.csv") => {
    // Create a Blob from the CSV content
    const blob = new Blob([csvContent], { type: "text/csv" });

    // Create a temporary link element
    const link = document.createElement("a");

    // Set the link's href to a URL created from the Blob
    const url = URL.createObjectURL(blob);
    link.href = url;

    // Set the link's download attribute to the desired filename
    link.download = filename;

    // Append the link to the document body
    document.body.appendChild(link);

    // Trigger a click event on the link to start the download
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);

    // Revoke the Blob URL to free up memory
    URL.revokeObjectURL(url);
  };

  const handleAttenSheet = (exam_title_idd) => {
    if (exam_title_idd) {
      AxiosInstance.post("api/batch/attendance/dwld", {
        batch_id: parseInt(id),
        exam_detail_pk: exam_title_idd,
      })
        .then((res) => {
          if (res.data.status === true) {
            const csvData =
              res.data.data &&
              res.data.data.stud_list.length > 0 &&
              res.data.data.stud_list.map((el, ind) => {
                return {
                  "S.No": ind + 1,
                  "Name of the candidate": el.full_name,
                  "Regsister No": `${el.aiasa_reg_no}`,
                  "District Name": el.district_name,
                };
              });
            const csvContent = convertToCSV(csvData);
            // Trigger the CSV download
            downloadCSV(csvContent, "AttendanceSheet.csv");
            handleAttenClose();
          } else {
            Swal.fire({
              title: "Warning",
              text: res.data.message,
              icon: "Warning",
              confirmButtonText: "Ok",
            });
            handleAttenClose();
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      console.log("exam_title_idd is missing");
    }
  };

  const handleCloseModels_Succ = () => {
    setSwalMsg({
      show: false,
      status: "",
      message: "",
      title: "",
      BottomOkClose: "",
    });

    // navigateToPreviousScreen();
  };

  const handleCloseModel = () => {
    setSwalMsg({
      show: false,
      status: "",
      message: "",
      title: "",
      BottomOkClose: "",
    });

    // navigateToPreviousScreen();
  };
  const handleViewStudent = (batch) => {
    const userID = batch.user_id;
    const batchID = batch.batch_id;
    const addID = batch?.pk;
    const type = typeFromParam;

    const stateData = {
      mode: mode,
      gender: gender,
      exam_district: exam_district,
      searchTerm: searchTerm,
      id: id,
      type: type,
      paymentMode: paymentMode,
      coreSubjects: coreSubjects,
      mediums: mediums,
      appDatas: appOns,
    };

    navigate(
      `/TransactionHistory/ViewAdmission/${userID}/${batchID}/${addID}/${type}/0`,
      { state: stateData }
    );
  };

  const handleModelExamAnalyticsNavigate = (Batchid, type) => {
    return navigate(`/ModelExamAnalytics/${type}`, {
      state: {
        batchID: Batchid,
        category: formFields.Category,
        course: formFields.Course,
        paperType: formFields.Papers,
        examName: formFields.Name,
        examMedium: formFields.MediumInstruction,
        batchImg: formFields.batchImg,
        examMode: formFields.ClassMode,
        numberofExams: formFields.NModelExam,
        examDistricts: selectedDistricts.length > 0 ? selectedDistricts : [],
        batchStatus: `${type === "4"
          ? currentDate.isBetween(
            formFields.StartDate,
            formFields.endDate,
            "day",
            "[]" // Include the end date
          ) && currentDate.isAfter(tenAMModelExam)
            ? "Ongoing"
            : currentDate.isBefore(formFields.StartDate, "day") ||
              (currentDate.isSame(formFields.StartDate, "day") &&
                currentDate.isBefore(tenAMModelExam))
              ? "Upcoming"
              : "Completed"
          : "-"
          }`,
        numberOfEnrolledStudents: formFields.EnrollStu,
        hallticketStatus: `${examDetail.length ===
          examDetail.filter((eop) => eop.hall_ticket_status === 2).length
          ? "Generated"
          : "Not Yet Generated"
          }  (${examDetail.length > 0 &&
          examDetail.filter((eop) => eop.hall_ticket_status === 2).length
          }/${formFields.NModelExam ? formFields.NModelExam : 0})`,
      },
    });
  };

  const handleRedirct = (arg) => {
    navigate(arg, {
      state: {
        filStatus: FSF,
        filCateCode: FCAF,
        fillClassMode: FCM,
        fillClassType: FIT,
        fillMedium: FME,
        fillLoca: FLO,
        fillShd: FSP,
        fillAon: FSTD,
        fillCOn: FCON,
        ftype: ftype,
        fillSearch: FSEAR,
      },
    });
  };

  const convertSecondsToTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const remainingSeconds = totalSeconds % 3600;
    const minutes = Math.floor(remainingSeconds / 60);

    // if (minutes > 0) {
    //   return `${hours}:${minutes.toString().padStart(2, "0")}`;
    // } else {
    //   return `${hours}`;
    // }
    const decimalMinutes = minutes / 60;
    const decimalTime = hours + decimalMinutes;

    return decimalTime.toFixed(2);
  };
  // const nearestLastDateApply = examDetail.reduce((nearest, exam) => {
  //   const examDate = moment(exam.LastDateApply, "DD-MM-YYYY");
  //   return !nearest || examDate.isBefore(nearest) ? examDate : nearest;
  // }, null);

  // const isButtonDisabled =
  //   nearestLastDateApply && nearestLastDateApply.isBefore(currentDate);

  const handleDRegsister = (batchIDD, EXDID) => {
    AxiosInstance.post("api/modelexam/registerno_download", {
      batch_id: batchIDD,
      exam_detail_id: EXDID,
    })
      .then((res) => {
        if (res.data.status === true) {
          setCsvListData(res.data.data);
        } else {
          Swal.fire({
            title: "Warning",
            text: res.data.message,
            icon: "Warning",
            confirmButtonText: "Ok",
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const generatePDF = () => {
    const headers = [
      // "S.No",
      "Name",
      "Admission ID",
      "Phone Number",
      "Email ID",
      // "Gender",
      // "Preferred Exam District",
      // "No. of Exams Enrolled",
      "Paid Amount",
      "Balance Fee",
    ];

    const rows = updateListData.map((item, index) => [
      // index + 1,
      item.fullname ?? "-",
      item.admission_id ?? "-",
      item.phone_no ?? "-",
      item.email ?? "-",
      // item.gender ?? "-",
      // item.exam_district ?? "-",
      // item.no_of_exams ?? "-",
      item.amount ?? "-",
      item.balance_amt ?? "-",
    ]);
    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Batch Student Data",
          headers,
          rows,
          filename: "BatchStudent.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };
  const csvHeaders = [
    { label: "Name", key: "fullname" },
    { label: "Email", key: "email" },
    { label: "Phone No", key: "phone_no" },
    { label: "Gender", key: "gender" },
    { label: "Fee Paid", key: "amount" },
    { label: "Balance Fee", key: "balance_amt" },
    { label: "Admission ID", key: "admission_id" },
    { label: "Main Exam Register Number", key: "main_exam_reg_no" },
    { label: "AIASA Hall Ticket URL", key: "hallticket_url" },
    { label: "Main Exam Hall Ticket URL", key: "original_mainexam_hallticket" },
    { label: "Class Mode", key: "class_mode" },
    { label: "Exam District", key: "exam_district" },
  ];
  const isMockInterview = type === "5";
  const isMockEditDisabled = isMockInterview && currentData?.length > 0;

  const handleChangeDate_app = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      setAppDatas((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };

        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;

        if (from && to) {
          const dateRange = `${from} - ${to}`;

          setAppOns([
            {
              name: dateRange,
              fdate: from,
              edate: to,
              type: "created_dt", //  CONSISTENT
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };
const sortedInterviewDetail = [...interviewDetail].sort(
  (a, b) => a.exam_count - b.exam_count
);

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className=" BathDet">
      <div className="row">
        <div className="col-md-12">
          {openHallModal && (
            <GenarateHallTicket
              hallTicketData={hallTicketData}
              handleMainHallThicket={handleMainHallThicket}
              show={openHallModal}
              handleHallClose={handleHallClose}
            />
          )}
          {openAttenModal && (
            <GenarateAttentenceSheet
              hallTicketData={attentData}
              handleMainHallThicket={handleAttenSheet}
              show={openAttenModal}
              handleHallClose={handleAttenClose}
            />
          )}
          {swalMsg.show === true && (
            <ModelComForP
              show={swalMsg.show}
              message={swalMsg.message}
              status={swalMsg.status}
              title={swalMsg.title}
              BottomOkBtn={swalMsg.BottomOkBtn}
              BottomCancelBtn={swalMsg.BottomCancelBtn}
              handleCloseModels={handleCloseModel}
              // handleClose_yes={handleSPayfee}
              BottomOkClose={swalMsg.BottomOkClose}
              handleCloseModels_Succ={handleCloseModels_Succ}
            />
          )}
          <section className="StepOne">
            <div className="row">
              <div className="col-md-3">
                <h6 className="Title ">
                  {type === "0" && "View Course Batch"}
                  {type === "1" && "View Test Batch"}
                  {type === "2" && "View Counselling Batch"}
                  {type === "3" && "View Special class Batch"}
                  {type === "4" && "View Model Exam Batch"}
                  {type === "5" && "View Mock Interview Batch"}
                </h6>
                {type === "0" && (
                  <Link
                    to={"javascript:void(0)"}
                    onClick={() => handleRedirct(`/ViewCourseBatch/${1}`)}
                    className="CancelButtons  MobileShow "
                  >
                    Back to Batches
                  </Link>
                )}

                {type === "1" && (
                  <Link
                    to={"javascript:void(0)"}
                    onClick={() => handleRedirct(`/ViewCourseBatch/${2}`)}
                    className="CancelButtons MobileShow "
                  >
                    Back to Batches
                  </Link>
                )}

                {type === "2" && (
                  <Link
                    to={"javascript:void(0)"}
                    onClick={() => handleRedirct(`/ViewCourseBatch/${4}`)}
                    className="CancelButtons MobileShow "
                  >
                    Back to Batches
                  </Link>
                )}

                {type === "3" && (
                  <Link
                    to={"javascript:void(0)"}
                    onClick={() => handleRedirct(`/ViewCourseBatch/${3}`)}
                    className="CancelButtons MobileShow "
                  >
                    Back to Batches
                  </Link>
                )}

                {type === "4" && (
                  <Link
                    to={"javascript:void(0)"}
                    onClick={() => handleRedirct(`/ViewCourseBatch/${5}`)}
                    className="CancelButtons MobileShow "
                  >
                    Back to Batches
                  </Link>
                )}

                {type === "5" && (
                  <Link
                    to={"javascript:void(0)"}
                    onClick={() => handleRedirct(`/ViewCourseBatch/${6}`)}
                    className="CancelButtons MobileShow "
                  >
                    Back to Batches
                  </Link>
                )}
              </div>
              <div className="col-md-9">
                <div className="NavButtons">
                  {type === "0" && (
                    <Link
                      to={"javascript:void(0)"}
                      onClick={() => handleRedirct(`/ViewCourseBatch/${1}`)}
                      className="CancelButtons MobileHide "
                    >
                      Back to Batches
                    </Link>
                  )}
                  {type === "1" && (
                    <Link
                      to={"javascript:void(0)"}
                      onClick={() => handleRedirct(`/ViewCourseBatch/${2}`)}
                      className="CancelButtons MobileHide mt-3"
                    >
                      Back to Batches
                    </Link>
                  )}
                  {type === "2" && (
                    <Link
                      to={"javascript:void(0)"}
                      onClick={() => handleRedirct(`/ViewCourseBatch/${4}`)}
                      className="CancelButtons MobileHide mt-3"
                    >
                      Back to Batches
                    </Link>
                  )}
                  {type === "3" && (
                    <Link
                      to={"javascript:void(0)"}
                      onClick={() => handleRedirct(`/ViewCourseBatch/${3}`)}
                      className="CancelButtons MobileHide mt-3"
                    >
                      Back to Batches
                    </Link>
                  )}
                  {type === "4" && (
                    <Link
                      to={"javascript:void(0)"}
                      onClick={() => handleRedirct(`/ViewCourseBatch/${5}`)}
                      className="CancelButtons MobileHide mt-3"
                    >
                      Back to Batches
                    </Link>
                  )}
                  {type === "5" && (
                    <Link
                      to={"javascript:void(0)"}
                      onClick={() => handleRedirct(`/ViewCourseBatch/${6}`)}
                      className="CancelButtons MobileHide mt-3"
                    >
                      Back to Batches
                    </Link>
                  )}
                  {type === "2" || type === "4" ? (
                    currentDate.isBetween(
                      formFields.StartDate,
                      formFields.endDate,
                      "day",
                      "[]" // Include the end date
                    ) ? (
                      <button type="button" className="ListViewBtn me-3 ">
                        <Link to={`javascript:void(0)`}>
                          <span className="material-icons me-1 fs-5 align-middle text-white">
                            border_color
                          </span>
                        </Link>

                        <Link to={`/CreateCourseBatch/${type}/${id}`}>
                          Edit {type === "0" && "Course Batch"}
                          {type === "1" && "Test Batch"}
                          {type === "2" && "Counselling Batch"}
                          {type === "3" && "Special class Batch"}
                          {type === "4" && "Model Exam Batch"}
                        </Link>
                      </button>
                    ) : currentDate.isBefore(formFields.StartDate, "day") ||
                      (currentDate.isSame(formFields.StartDate, "day") &&
                        currentDate.isBefore(tenAMModelExam)) ? (
                      <button type="button" className="ListViewBtn me-3 ">
                        <Link to={`javascript:void(0)`}>
                          <span className="material-icons me-1 fs-5 align-middle text-white">
                            border_color
                          </span>
                        </Link>

                        <Link to={`/CreateCourseBatch/${type}/${id}`}>
                          Edit {type === "0" && "Course Batch"}
                          {type === "1" && "Test Batch"}
                          {type === "2" && "Counselling Batch"}
                          {type === "3" && "Special class Batch"}
                          {type === "4" && "Model Exam Batch"}
                        </Link>
                      </button>
                    ) : (
                      <button
                        disabled
                        type="button"
                        className="ListViewBtn DisabledListvi  me-3 "
                      >
                        <Link to={`javascript:void(0)`}>
                          <span className="material-icons me-1 fs-5 align-middle text-white">
                            border_color
                          </span>
                        </Link>

                        <Link to={`javascript:void(0)`}>
                          Edit {type === "0" && "Course Batch"}
                          {type === "1" && "Test Batch"}
                          {type === "2" && "Counselling Batch"}
                          {type === "3" && "Special class Batch"}
                          {type === "4" && "Model Exam Batch"}
                        </Link>
                      </button>
                    )
                  ) : (
                    type != "5" && (
                      <button type="button" className="ListViewBtn me-3 ">
                        <Link to={`javascript:void(0)`}>
                          <span className="material-icons me-1 fs-5 align-middle text-white">
                            border_color
                          </span>
                        </Link>

                        <Link to={`/CreateCourseBatch/${type}/${id}`}>
                          Edit {type === "0" && "Course Batch"}
                          {type === "1" && "Test Batch"}
                          {type === "2" && "Counselling Batch"}
                          {type === "3" && "Special class Batch"}
                          {type === "4" && "Model Exam Batch 1"}
                        </Link>
                      </button>
                    )
                  )}
                  {type === "5" ? (
                    currentDate.isBetween(
                      formFields.StartDate,
                      formFields.endDate,
                      "day",
                      "[]"
                    ) && currentDate.isAfter(tenAMModelExam) ? (
                      <button type="button" className="ListViewBtn me-3">
                        <Link to="javascript:void(0)">
                          <span className="material-icons me-1 fs-5 align-middle text-white">
                            border_color
                          </span>
                        </Link>

                        <Link to={`/CreateCourseBatch/${type}/${id}`}>
                          Edit Mock Interview Batch
                        </Link>
                      </button>
                    ) : currentDate.isBefore(formFields.StartDate, "day") ||
                      (currentDate.isSame(formFields.StartDate, "day") &&
                        currentDate.isBefore(tenAMModelExam)) ? (
                      <button type="button" className="ListViewBtn me-3">
                        <Link to="javascript:void(0)">
                          <span className="material-icons me-1 fs-5 align-middle text-white">
                            border_color
                          </span>
                        </Link>

                        <Link to={`/CreateCourseBatch/${type}/${id}`}>
                          Edit Mock Interview Batch
                        </Link>
                      </button>
                    ) : (
                      <button
                        disabled
                        type="button"
                        className="ListViewBtn DisabledListvi me-3"
                      >
                        <Link to="javascript:void(0)">
                          <span className="material-icons me-1 fs-5 align-middle text-white">
                            border_color
                          </span>
                        </Link>

                        <Link to="javascript:void(0)">
                          Edit Mock Interview Batch
                        </Link>
                      </button>
                    )
                  ) : (
                    /* ✅ Other batch types – unchanged */

                    <></>
                  )}

                  {type === "5" && (
                    <>
                      <button
                        type="button"
                        className={`ListViewBtn me-3 ${isGenerateDisabled ? "disabledbtn" : ""
                          }`}
                      >
                        <Link
                          onClick={
                            !isGenerateDisabled
                              ? handleGenerateCallLetter
                              : undefined
                          }
                          to="javascript:void(0)"
                        >
                          Generate Call Letter
                        </Link>
                      </button>
                      <button type="button" className="ListViewBtn  me-3">
                        <Link onClick={handleInterview} to="javascript:void(0)">
                          Interview
                        </Link>
                      </button>
                      {open && (
                        <Modal
                          key={`modal-0-${0}`}
                          show={open}
                          onHide={handleModelClose}
                          size="xl"
                          centered
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>
                              <h5
                                className={` fw-bold mb-0`}
                                id="exampleModalLabel"
                              >
                                Generate AIASA's Call Letter
                              </h5>
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <></>

                            <div className="row global_container">
                              <div className="col-12">
                                <form className="row ">
                                  <div class="col-md-12">
                                    <label
                                      for="ratingStar"
                                      class="form-label confirm_value "
                                    >
                                      Are you sure you want to generate the
                                      interview call letter for the interview
                                      titled {latestInterview?.title} for{" "}
                                      {latestInterview?.date}?
                                    </label>
                                  </div>

                                  <div class="col-md-6">
                                    <label
                                      for="iframe"
                                      class="form-label confirm_value "
                                    >
                                      Interview Title
                                    </label>
                                    <div>
                                      <label
                                        for="iframe"
                                        class="form-label confirm_label "
                                      >
                                        {latestInterview?.title}
                                      </label>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <label
                                      for="iframe"
                                      class="form-label confirm_value "
                                    >
                                      Date
                                    </label>
                                    <div>
                                      <label
                                        for="iframe"
                                        class="form-label confirm_label "
                                      >
                                        {latestInterview?.date}
                                      </label>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  onClick={handleModelClose}
                                  className="secondaryButton"
                                >
                                  Back to View Mock Interview Batch
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  onClick={handleSubmit}
                                  className="primaryButton"
                                >
                                  Generate Now
                                </Link>
                              </li>
                            </ul>
                          </Modal.Footer>
                        </Modal>
                      )}
                    </>
                  )}

                  {type === "4" && (
                    <>
                      <button
                        type="button"
                        // className={`ListViewBtn me-3 `}
                        className={`ListViewBtn me-3 ${examDetail.length > 0 &&
                          examDetail.every((eo) => eo.hall_ticket_status === 2)
                          ? "DisabledListvi"
                          : ""
                          } `}
                        disabled={
                          examDetail.length > 0 &&
                            examDetail.every((eo) => eo.hall_ticket_status === 2)
                            ? true
                            : false
                        }
                        onClick={handleExamCentreNavigation}
                      >
                        <Link>
                          <p className="p-0 m-0 d-flex align-items-center">
                            {" "}
                            <span class="material-icons-outlined">
                              location_on
                            </span>
                            <span> Exam Centres</span>
                          </p>
                        </Link>
                      </button>
                      <button
                        type="button"
                        onClick={
                          formFields.EnrollStu > 0 &&
                            districtWise.length > 0 &&
                            districtWise.every(
                              (el) =>
                                el.examCenter.length > 0 &&
                                el.examCenter.every(
                                  (ell) => ell.exam_center !== ""
                                )
                            )
                            ? () => handleOpenHallPopup()
                            : () => handleFailureCase()
                        }
                        className={`ListViewBtn  me-3`}
                      >
                        <Link to={`javascript:void(0)`}>
                          <span className="material-icons me-1 fs-5 align-middle text-white">
                            email
                          </span>
                        </Link>
                        <Link to={`javascript:void(0)`}>
                          Generate AIASA's Hall Ticket
                        </Link>
                      </button>
                      <button
                        className={`ListViewBtn me-3 ${examDetail.length == 0
                          ? "DisabledListvi"
                          : ""
                          } `}
                        disabled={
                          examDetail.length == 0
                        }
                        onClick={() =>
                          handleModelExamAnalyticsNavigate(id, type)
                        }
                      >
                        <IconAnalytics color="#fff" className="fs-5" />
                        Model Exam Analytics
                      </button>

                      <button
                        type="button"
                        className={`ListViewBtn me-3 ${examDetail.length > 0 &&
                          moment(
                            examDetail[0].LastDateApply,
                            "DD-MM-YYYY"
                          ).isAfter(currentDate)
                          ? "DisabledListvi"
                          : ""
                          } `}
                        disabled={
                          examDetail.length > 0 &&
                          moment(
                            examDetail[0].LastDateApply,
                            "DD-MM-YYYY"
                          ).isAfter(currentDate)
                        }
                        onClick={() => handleGenReport()}
                      >
                        <Link>
                          <p className="p-0 m-0 d-flex align-items-center">
                            <IconAnalytics color="#fff" className="fs-5" />
                            <span>Generate Report</span>
                          </p>
                        </Link>
                      </button>
                    </>
                  )}
                  {type === "4" && (
                    <button type="button" className="ListViewBtn  me-3">
                      <Link to={`javascript:void(0)`}>
                        <span className="material-icons me-1 fs-5 align-middle text-white">
                          {formFields.ask_core_exam === 0
                            ? "assignment"
                            : "block"}
                        </span>
                      </Link>

                      <Link
                        onClick={() =>
                          handleCoreExam(id, formFields.ask_core_exam)
                        }
                      >
                        {formFields.ask_core_exam === 0
                          ? "Request Student's Hall Ticket"
                          : "Cancel Hall Ticket Request"}
                      </Link>
                    </button>
                  )}
                  {type === "4" && (
                    <button type="button" className="ListViewBtn  me-3">
                      <Link
                        onClick={handleCenterSupervisor}
                        to="javascript:void(0)"
                      >
                        Centre Supervisors
                      </Link>
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="row box">
              <div className="col-md-12">
                <p className="StepTitle">Basic Details</p>
                <div className="row">
                  <div className="col-md-9">
                    <div className="row">
                      <div className="col-lg-4 col-md-6">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted mt-2 "
                          >
                            Category
                          </label>
                          <span className="ReviewLabel">
                            {formFields.Category || ""}
                          </span>
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted mt-2 "
                          >
                            Course
                          </label>
                          <span className="ReviewLabel">
                            {" "}
                            {formFields.Course || ""}
                          </span>
                        </div>
                      </div>
                      {type === "4" && (
                        <div className="col-lg-4 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Single Papers / Combined Papers?
                            </label>
                            <span className="ReviewLabel">
                              {" "}
                              {formFields.Papers === "0"
                                ? "Single Papers"
                                : "Combined Papers" || ""}
                            </span>
                          </div>
                        </div>
                      )}
                      <div className="col-md-4">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted mt-2 "
                          >
                            Batch Name
                          </label>
                          <span className="ReviewLabel">
                            {formFields.Name || ""}
                          </span>
                        </div>
                      </div>
                      {type !== "4" && type !== "5" && (
                        <div className="col-md-4">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Section
                            </label>
                            <span className="ReviewLabel">
                              {formFields.Section || ""}
                            </span>
                          </div>
                        </div>
                      )}
                      {type === "5" && (
                        <>
                          <div className="col-md-4">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                Mock Interview Type
                              </label>
                              <span className="ReviewLabel">
                                {formFields.Papers == 0
                                  ? "Interview"
                                  : "Class Cum Interview" || ""}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                Batch Mode
                              </label>
                              <span className="ReviewLabel">
                                {formFields.ClassMode || ""}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                No of Interview
                              </label>
                              <span className="ReviewLabel">
                                {interviewDetail.length || ""}
                              </span>
                            </div>
                          </div>
                        </>
                      )}

                      {type !== "4" && (
                        <div className="col-lg-4 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Location
                            </label>
                            <span className="ReviewLabel">
                              {formFields.location || ""}
                              {/* {formFields.location === "1" ?  "Tambaram": "" }
                            {formFields.location === "3" ?  "Vellore": "" }
                            {formFields.location === "4" ?  "Ch - Anna Nagar": "" } */}
                            </span>
                          </div>
                        </div>
                      )}

                      {type != "5" && type != "2" && (
                        <div className="col-lg-4 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              {type === "1"
                                ? "Test Mode"
                                : type === "4"
                                  ? "Mode of Exam"
                                  : "Class Mode"}
                            </label>
                            <span className="ReviewLabel">
                              {formFields.ClassMode === "ClassRoom"
                                ? "Classroom"
                                : "Online" || ""}
                            </span>
                          </div>
                        </div>
                      )}

                      {type === "4" && (
                        <div className="col-lg-4 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Exam Districts
                            </label>
                            <span className="ReviewLabel">
                              {selectedDistricts.length > 0
                                ? selectedDistricts
                                  .map((el) => el.label)
                                  .join(", ")
                                : "_"}
                            </span>
                          </div>
                        </div>
                      )}

                      {type === "4" && (
                        <div className="col-lg-4 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Number of Model Exams
                            </label>
                            <span className="ReviewLabel">
                              {/* {formFields.NModelExam || ""} */}
                              {formFields.NModelExam
                                ? formFields.NModelExam
                                : 0}
                            </span>
                          </div>
                        </div>
                      )}

                      {type != "5" && type != "2" && (
                        <div className="col-lg-4 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              {type === "4"
                                ? "Medium of Exam"
                                : "Medium of Instruction"}
                            </label>
                            <span className="ReviewLabel">
                              {formFields.MediumInstruction || ""}
                            </span>
                          </div>
                        </div>
                      )}

                      {type !== "4" && (
                        <div className="col-lg-4 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Total Number of Students
                            </label>
                            <span className="ReviewLabel">
                              {" "}
                              {formFields.NoStudents || ""}
                            </span>
                          </div>
                        </div>
                      )}

                      {type === "1" && (
                        <div className="col-lg-4 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Total Number of Test
                            </label>
                            <span className="ReviewLabel">
                              {" "}
                              {formFields.NoTest || ""}
                            </span>
                          </div>
                        </div>
                      )}

                      {type !== "4" && type !== "2" && type !== "5" && (
                        <div className="col-lg-4 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Subject
                            </label>
                            <span className="ReviewLabel">
                              {" "}
                              {formFields.subject || "None"}
                            </span>
                          </div>
                        </div>
                      )}

                      {type === "1" && (
                        <div className="col-lg-4 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Test Details
                            </label>
                            <a
                              className="ReviewLabel text-danger"
                              target="_blank"
                              href={`${ImageUrlPrefix}/${formFields.TestPdf}`}
                            >
                              {formFields.TestPdf != null
                                ? formFields.original_test_img_url
                                : ""}
                            </a>
                          </div>
                        </div>
                      )}

                      {type === "3" && (
                        <div className="col-lg-4 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Subject Syllabus{" "}
                            </label>
                            <a
                              className="ReviewLabel text-danger"
                              target="_blank"
                              href={`${ImageUrlPrefix}/${formFields.subject_file_path}`}
                            >
                              {formFields.subject_file_path != null
                                ? formFields.original_subject_file_path
                                : ""}
                            </a>
                          </div>
                        </div>
                      )}

                      {type === "2" && (
                        <div className="col-lg-4 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Name of exam passed
                            </label>
                            <span className="ReviewLabel">
                              {" "}
                              {formFields.exampassed || ""}
                            </span>
                          </div>
                        </div>
                      )}
                      <div className="col-lg-4 col-md-6">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted mt-2 "
                          >
                            Number of Enrolled Students
                          </label>
                          <span className="ReviewLabel">
                            {" "}
                            {formFields.EnrollStu || ""}
                          </span>
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted mt-2 "
                          >
                            Batch Status
                          </label>
                          {/* AIASA-000185 - v1 issues solved by lalitha */}

                          {/* // based on start date and duration i show the status */}
                          {type === "2" || type === "5" || type === "4" ? (
                            // console.log("formFields.StartDate ", modelExamRecentObj),
                            type === "4" ? (
                              currentDate.isSameOrBefore(modelExamRecentObj, "day") ? (
                              <td id="td">
                                <span className=" ReviewLabel PinkText">
                                  Upcoming
                                </span>
                              </td>
                            ) : currentDate.isBetween(
                              formFields.StartDate,
                              formFields.endDate,
                              "day",
                              "[]" // Include the end date
                            )  ? (
                              <td id="td">
                                <span className="ReviewLabel GreenTexts">
                                  Ongoing
                                </span>
                              </td>
                            ) : (
                              <td id="td">
                                <span className=" ReviewLabel GreyText">
                                  Completed
                                </span>
                              </td>
                            )
                            ):(
                              currentDate.isBetween(
                              formFields.StartDate,
                              formFields.endDate,
                              "day",
                              "[]" // Include the end date
                            ) && currentDate.isAfter(tenAMModelExam) ? (
                              <td id="td">
                                <span className="ReviewLabel GreenTexts">
                                  Ongoing
                                </span>
                              </td>
                            ) : currentDate.isBefore(
                              formFields.StartDate,
                              "day"
                            ) ||
                              (currentDate.isSame(
                                formFields.StartDate,
                                "day"
                              ) &&
                                currentDate.isBefore(tenAMModelExam)) ? (
                              <td id="td">
                                <span className=" ReviewLabel PinkText">
                                  Upcoming
                                </span>
                              </td>
                            ) : (
                              <td id="td">
                                <span className=" ReviewLabel GreyText">
                                  Completed
                                </span>
                              </td>
                            )
                            )
                          ) : (
                            <ReviewstatusCheck
                              startDate={formFields.StartDate}
                              duration={formFields.Duration}
                            />
                          )}
                        </div>
                      </div>

                      {type === "4" && (
                        <div className="col-lg-4 mb-3 col-md-6">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Hall Ticket Status
                            </label>
                            <span className="ReviewLabel">
                              {`${examDetail.length ===
                                examDetail.filter(
                                  (eop) => eop.hall_ticket_status === 2
                                ).length
                                ? "Generated"
                                : examDetail.length > 0 &&
                                  examDetail.filter(
                                    (eop) => eop.hall_ticket_status === 2
                                  ).length >= 1
                                  ? "Generated"
                                  : "Not Yet Generated"
                                }  (${examDetail.length > 0 &&
                                examDetail.filter(
                                  (eop) => eop.hall_ticket_status === 2
                                ).length
                                }/${formFields.NModelExam
                                  ? formFields.NModelExam
                                  : 0
                                })`}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-5">
                    <div className="forms mt-4 mb-2  ">
                      <div id="batchImage">
                        {formFields.batchImg && (
                          <img
                            // src={`${ImageUrlPrefix}/${formFields.batchImg}`}
                            src={`${ImageUrlPrefix}/${formFields.batchImg}`}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {type !== "4" && type !== "5" && type !== "2" && (
            <section className="StepOne">
              <div className="row box">
                <div className="col-md-12">
                  <p className="StepTitle">Schedule</p>
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <div className="row">
                        {type != "4" && type != "5" && type != "2" && (
                          <div className="col-lg-3 col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                Schedule Preference
                              </label>
                              <span className="ReviewLabel">
                                {formFields.SchedulePreference || ""}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="col-lg-3 col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Start Date
                            </label>
                            <span className="ReviewLabel">
                              {" "}
                              {formFields.StartDate
                                ? moment(formFields.StartDate).format(
                                  "DD/MM/YYYY"
                                )
                                : "" || ""}
                            </span>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Time
                            </label>
                            <span className="ReviewLabel">
                              {" "}
                              {moment(formFields.Time, "h:mm:ss A").format(
                                "h:mm A"
                              )}
                              -{" "}
                              {moment(formFields.endTime, "h:mm:ss A").format(
                                "h:mm A"
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              {type !== "4"
                                ? "Duration (in Months)"
                                : "Duration (in Hours)"}
                            </label>
                            <span className="ReviewLabel">
                              {" "}
                              {formFields.Duration || ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          {type !== "4" && type !== "5" && type !== "2" && (
            <section className="StepOne">
              <div className="row box">
                <div className="col-md-12">
                  <p className="StepTitle">Partial Payment</p>
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Eligible for Partial Payment?
                            </label>
                            <span className="ReviewLabel">
                              {formFields.pPayment || ""}
                            </span>
                          </div>
                        </div>
                        {formFields.pPayment === "Yes" && (
                          <div className="col-lg-6 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                1st Payment Percentage
                              </label>
                              <span className="ReviewLabel">
                                {" "}
                                {formFields.perOne || ""}
                              </span>
                            </div>
                          </div>
                        )}

                        {formFields.pPayment === "Yes" && (
                          <div className="col-lg-6 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                1st Payment Date
                              </label>
                              <span className="ReviewLabel">
                                Student's Admission Date
                              </span>
                            </div>
                          </div>
                        )}

                        {formFields.pPayment === "Yes" && (
                          <div className="col-lg-6 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                2nd Payment Percentage
                              </label>
                              <span className="ReviewLabel">
                                {formFields.perTwo || ""}
                              </span>
                            </div>
                          </div>
                        )}

                        {formFields.pPayment === "Yes" && (
                          <div className="col-lg-6 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                2nd Payment Date
                              </label>
                              <span className="ReviewLabel">
                                {formFields.perTwoDate || ""}
                              </span>
                            </div>
                          </div>
                        )}
                        {formFields.pPayment === "Yes" && (
                          <div className="col-lg-6 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                3rd Payment Percentage
                              </label>
                              <span className="ReviewLabel">
                                {formFields.perThree || ""}
                              </span>
                            </div>
                          </div>
                        )}

                        {formFields.pPayment === "Yes" && (
                          <div className="col-lg-6 col-md-6">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                3rd Payment Date
                              </label>
                              <span className="ReviewLabel">
                                {formFields.perThreeDate || ""}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          {type !== "4" && type !== "5" && type !== "2" && (
            <section className=" StepOne">
              <div className="row box">
                <div className="col-md-12">
                  <p className="StepTitle">Fees and Discounts</p>

                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-2 col-md-4 mb-3">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted mt-2 "
                          >
                            Fees
                          </label>
                          <span className="ReviewLabel">
                            {" "}
                            ₹ {formFields.Fees || ""}
                          </span>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-4 mb-3">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted mt-2 "
                          >
                            Special Offer (if any)
                          </label>
                          <span className="ReviewLabel">
                            {" "}
                            ₹ {formFields.Discount || "0"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          {/* {type === "5" && (
            <div className="row">
              {mockPanel.map((el, index) => (
                <div className="col-md-12" key={index}>
                  <ReviewMockPanelMember record={el} />
                </div>
              ))}
            </div>
          )} */}
          {type === "5" && (
            <>
              <section className=" StepOne">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle">Other Applicable Batches</p>
                    <div className="row mb-3 ">
                      <div className="col-md-6">
                        <div className="forms ">
                          <label
                            htmlFor="inputName"
                            className="form-label text-muted"
                          >
                            Other Applicable Batches
                          </label>

                          {oth_app_batch.length > 0 ? (
                            <span className="ReviewLabel">
                              {oth_app_batch.map((lk, index) => (
                                <React.Fragment key={index}>
                                  {index > 0 && ", "} {lk}
                                </React.Fragment>
                              ))}
                            </span>
                          ) : (
                            <span className="ReviewLabel">_</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <div className="row">
                {sortedInterviewDetail.map((el, index) => (
                  <div
                    className={
                      sortedInterviewDetail.length % 2 !== 0
                        ? sortedInterviewDetail.length - 1 === index
                          ? "col-md-12"
                          : "col-md-12 "
                        : "col-md-12 "
                    }
                    key={index}
                  >
                    <section className="StepOne">
                      <div className="row box">
                        <div className="col-md-12">
                          <p className="StepTitle">
                            Interview{" "}
                            {sortedInterviewDetail.length > 0 ? `${el.exam_count}` : ""}{" "}
                            Details
                          </p>
                          <div className="row mb-3">
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Interview Title{" "}
                                </label>
                                <span className="ReviewLabel">
                                  {el.title || ""}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Interview Date
                                </label>
                                <span className="ReviewLabel">
                                  {el.date ? el.date : ""}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Last Date to Apply
                                </label>
                                <span className="ReviewLabel">
                                  {" "}
                                  {moment(
                                    el.LastDateApply,
                                    "DD/MM/YYYY"
                                  ).format("DD/MM/YYYY") || ""}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-3 ">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Uploaded Exam Syllabus
                                  {el.syllabus_url !== "" &&
                                    el.syllabus_url !== null && (
                                      <a
                                        target="_blank"
                                        href={`${ImageUrlPrefix}/${el.syllabus_url}`}
                                      >
                                        {" "}
                                        <Download className="download_icon" />
                                      </a>
                                    )}
                                </label>
                                <span className="ReviewLabel">
                                  {el.original_syllabus_url !== null
                                    ? el.original_syllabus_url
                                    : ""}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Students Enrolled
                                </label>
                                <span className="ReviewLabel">
                                  {el.student_count ?? "-"}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Call Letter Status{" "}
                                </label>
                                <span className="ReviewLabel">
                                  {el.hall_ticket_status == "0"
                                    ? "Not Yet Generated"
                                    : "Generated" || "-"}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Result Status{" "}
                                </label>
                                <span className="ReviewLabel">
                                  {el.result_status == 0
                                    ? "Not Yet Published"
                                    : "Published" || "-"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                ))}
              </div>

              <div className="row">
                {sortedSlabDetails.map((el, index) => (
                  <div key={index}>
                    <section className="StepOne">
                      <div className="row box">
                        <div className="col-md-12">
                          <p className="StepTitle">
                            Slab{" "}
                            {sortedSlabDetails.length > 0
                              ? `${el.slab_count}`
                              : ""}{" "}
                            Details
                          </p>
                          <div className="row mb-3">
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Slab Name{" "}
                                </label>
                                <span className="ReviewLabel">
                                  {el.name ?? "-"}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Slab Mark
                                </label>
                                <span className="ReviewLabel">
                                  {el.mark ?? "-"}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Minimum Mark
                                </label>
                                <span className="ReviewLabel">
                                  {el.min_mark ?? "-"}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  maximum Mark
                                </label>
                                <span className="ReviewLabel">
                                  {el.max_mark ?? "-"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                ))}
              </div>
            </>
          )}
          {type === "5" && (
            <div className="row">
              <div className="col-md-12">
                <ReviewFeesDetails feesDetails={feesDetails} type={5} />
              </div>
            </div>
          )}

          {type === "2" && (
            <div className="row">
              {cPanel.map((el, index) => (
                <div className="col-md-12" key={index}>
                  <ReviewCounselingPanel record={el} />
                </div>
              ))}
            </div>
          )}

          {type === "2" && (
            <div className="row">
              {cPanel.map((el, index) => (
                <div className="col-md-12" key={index}>
                  <ReviewFeesDetails record={el} type={2} />
                </div>
              ))}
            </div>
          )}

          {type === "4" && (
            <div className="row">
              {examDetail.map((el, index) => (
                <div
                  className={
                    examDetail.length % 2 !== 0
                      ? examDetail.length - 1 === index
                        ? "col-md-12"
                        : "col-md-12 "
                      : "col-md-12 "
                  }
                  key={index}
                >
                  <section className="StepOne">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">
                          Model Exam{" "}
                          {examDetail.length > 0 ? `${index + 1}` : ""} Details
                        </p>
                        <div className="row mb-3">
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                Exam Title{" "}
                              </label>
                              <span className="ReviewLabel">
                                {el.title || ""}
                              </span>
                            </div>
                          </div>
                          {formFields.Papers === "0" && (
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Date
                                </label>
                                <span className="ReviewLabel">
                                  {el.date ? el.date : ""}
                                </span>
                              </div>
                            </div>
                          )}
                          {formFields.Papers === "0" && (
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Duration (in Hours)
                                </label>
                                <span className="ReviewLabel">
                                  {el.duration || ""}
                                </span>
                              </div>
                            </div>
                          )}
                          {formFields.Papers === "0" && (
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Time
                                </label>
                                <span className="ReviewLabel">
                                  {el.startTime
                                    ? moment(el.startTime, "h:mm:ss A").format(
                                      "h:mm A"
                                    )
                                    : "_"}{" "}
                                  to{" "}
                                  {el.endTime
                                    ? moment(el.endTime, "h:mm:ss A").format(
                                      "h:mm A"
                                    )
                                    : "_"}
                                </span>
                              </div>
                            </div>
                          )}
                          {formFields.Papers === "0" && (
                            <div className="col-md-3 ">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Uploaded Exam Syllabus
                                  {el.syllabus !== "" &&
                                    el.syllabus !== null && (
                                      <a
                                        target="_blank"
                                        href={`${ImageUrlPrefix}/${el.syllabus_url}`}
                                      >
                                        {" "}
                                        <Download className="download_icon" />
                                      </a>
                                    )}
                                </label>
                                <span className="ReviewLabel">
                                  {el.original_syllabus_url !== null
                                    ? el.original_syllabus_url
                                    : ""}
                                </span>
                              </div>
                            </div>
                          )}

                          {formFields.Papers === "1" && (
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  No of Papers
                                </label>
                                <span className="ReviewLabel">
                                  {" "}
                                  {el.NPapers || ""}
                                </span>
                              </div>
                            </div>
                          )}

                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                Last Date to Apply
                              </label>
                              <span className="ReviewLabel">
                                {" "}
                                {moment(el.LastDateApply, "DD/MM/YYYY").format(
                                  "DD/MM/YYYY"
                                ) || ""}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                Hall Ticket status
                              </label>
                              <span className="ReviewLabel">
                                {el.hall_ticket_status === 0
                                  ? "Not Yet Generated"
                                  : el.hall_ticket_status === 1
                                    ? "Hall tickets are being generated now"
                                    : `Generated ${el.student_count > 0 &&
                                    `(${el.student_count})`
                                    }`}
                              </span>
                            </div>
                          </div>
                          {el.hall_ticket_status === 2 && (
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Register Number List
                                  <Download
                                    onClick={() => handleDRegsister(id, el.pk)}
                                    className="download_icon"
                                  />
                                  <CSVLink
                                    data={csvListData}
                                    filename={"RegisterNumberList.csv"}
                                    ref={csvLinkRef}
                                    className="hidden" // Hide the actual CSVLink element
                                  />
                                </label>
                                <span className="ReviewLabel">
                                  RegisterNumberList.csv
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              ))}
            </div>
          )}

          {type === "4" && (
            <div className="row">
              {districtWise.length > 0 &&
                districtWise.map((el, index) => (
                  <div className="col-md-12" key={index}>
                    <section className="StepOne">
                      <div className="row box">
                        <div className="col-md-12 ">
                          <p className="StepTitle">
                            Exam District{" "}
                            {districtWise.length > 0 ? `- ${el.id}` : ""}
                          </p>
                          <div className="row mt-2">
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  District
                                </label>
                                <span className="ReviewLabel">
                                  {el.district && el.district.label
                                    ? el.district.label
                                    : ""}
                                  {el.districtCode &&
                                    `(${el.districtCode ? el.districtCode : "_"
                                    })`}
                                </span>
                              </div>
                            </div>
                            {/* {
                              el.enroll_count.length > 0  ?
                              el.enroll_count.map((eop , index) => (
                                <>
                                  <div className="col-md-3">
                                    <div className="forms ">
                                      <label
                                        htmlFor="inputName"
                                        className="form-label text-muted mt-2 "
                                      >
                                        Total Number of Students Enrolled
                                      </label>
                                      <span className="ReviewLabel">
                                        {eop.gender_cnt ? eop.gender_cnt : "_"}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-md-2">
                                    <div className="forms ">
                                      <label
                                        htmlFor="inputName"
                                        className="form-label text-muted mt-2 "
                                      >
                                        Male
                                      </label>
                                      <span className="ReviewLabel">
                                        {
                                          el.enroll_count.filter(
                                            (elop) => elop.gender === "Male"
                                          ).length
                                        }
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-md-2">
                                    <div className="forms ">
                                      <label
                                        htmlFor="inputName"
                                        className="form-label text-muted mt-2 "
                                      >
                                        Female
                                      </label>
                                      <span className="ReviewLabel">
                                        {
                                          el.enroll_count.filter(
                                            (elop) => elop.gender === "Female"
                                          ).length
                                        }
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-md-2">
                                    <div className="forms ">
                                      <label
                                        htmlFor="inputName"
                                        className="form-label text-muted mt-2 "
                                      >
                                        Transgender
                                      </label>
                                      <span className="ReviewLabel">
                                        {
                                          el.enroll_count.filter(
                                            (elop) =>
                                              elop.gender === "Transgender"
                                          ).length
                                        }
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )) : (
                                <>
                                <div className="col-md-3">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted mt-2 "
                                    >
                                      Total Number of Students Enrolled
                                    </label>
                                    <span className="ReviewLabel">
                                    {"_"}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-2">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted mt-2 "
                                    >
                                      Male
                                    </label>
                                    <span className="ReviewLabel">
                                    {"_"}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-2">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted mt-2 "
                                    >
                                      Female
                                    </label>
                                    <span className="ReviewLabel">
                                    {"_"}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-2">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted mt-2 "
                                    >
                                      Transgender
                                    </label>
                                    <span className="ReviewLabel">
                                      {"_"}
                                    </span>
                                  </div>
                                </div>
                              </>

                              )} */}

                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Total Number of Students Enrolled
                                </label>
                                <span className="ReviewLabel">
                                  {/* { parseInt(el.enroll_count.filter( (elop) => elop.gender === "Male").map((el) =>el.gender_cnt))
                                     + parseInt(el.enroll_count.filter( (elop) => elop.gender === "Female").map((el) =>el.gender_cnt))
                                     + parseInt(el.enroll_count.filter( (elop) => elop.gender === "Transgender").map((el) =>el.gender_cnt)) > 0 ? parseInt(el.enroll_count.filter( (elop) => elop.gender === "Transgender").map((el) =>el.gender_cnt)) : 0} */}
                                  {el.enroll_count.reduce(
                                    (total, item) => total + item.gender_cnt,
                                    0
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Male
                                </label>
                                <span className="ReviewLabel">
                                  {el.enroll_count
                                    .filter((elop) => elop.gender === "Male")
                                    .map((el) => el.gender_cnt) > 0
                                    ? el.enroll_count
                                      .filter(
                                        (elop) => elop.gender === "Male"
                                      )
                                      .map((el) => el.gender_cnt)
                                    : "_"}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Female
                                </label>
                                <span className="ReviewLabel">
                                  {el.enroll_count
                                    .filter((elop) => elop.gender === "Female")
                                    .map((el) => el.gender_cnt) > 0
                                    ? el.enroll_count
                                      .filter(
                                        (elop) => elop.gender === "Female"
                                      )
                                      .map((el) => el.gender_cnt)
                                    : "_"}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Transgender
                                </label>
                                <span className="ReviewLabel">
                                  {el.enroll_count
                                    .filter(
                                      (elop) => elop.gender === "Transgender"
                                    )
                                    .map((el) => el.gender_cnt) > 0
                                    ? el.enroll_count
                                      .filter(
                                        (elop) =>
                                          elop.gender === "Transgender"
                                      )
                                      .map((el) => el.gender_cnt)
                                    : "_"}
                                </span>
                              </div>
                            </div>
                          </div>

                          {el.examCenter &&
                            el.examCenter.length > 0 &&
                            el.examCenter.map((ell) => (
                              <div className="row mb-2">
                                <div className="col-md-3">
                                  <div className="forms ">
                                    <div className="d-flex align-items-center">
                                      <label
                                        htmlFor="inputName"
                                        className="form-label text-muted mt-2 "
                                      >
                                        Exam Center
                                      </label>
                                      <Switch
                                        className="radioSwitchBtn"
                                        checked={
                                          ell.redwnld_req_approved
                                            ? ell.redwnld_req_approved === 0
                                              ? false
                                              : true
                                            : false
                                        }
                                        onClick={() =>
                                          handleChangeRadio(ell.pk)
                                        }
                                        inputProps={{
                                          "aria-label": "controlled",
                                        }}
                                      />
                                    </div>

                                    <span className="ReviewLabel">
                                      {ell.exam_center ? ell.exam_center : "_"}
                                    </span>
                                    {ell.locationUrl !== null &&
                                      ell.locationUrl !== "" &&
                                      ell.locationUrl !== "null" && (
                                        <a
                                          target="_balank"
                                          href={`${ell.locationUrl}`}
                                          className="ReviewLabelText"
                                        >
                                          {`(${ell.locationUrl})`}
                                        </a>
                                      )}
                                    <span className="ReviewLabel">
                                      {ell.full_name
                                        ? `(${ell.full_name} - ${ell.mobile_no})`
                                        : ""}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-3">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted mt-2 "
                                    >
                                      Max Count
                                    </label>
                                    <span className="ReviewLabel">
                                      {ell.MaxCount ? ell.MaxCount : 0}
                                      {/* {ell.enroll_count.length > 0 ? ell.enroll_count.length : "_"} */}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-2">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted mt-2 "
                                    >
                                      Male
                                    </label>
                                    <span className="ReviewLabel">
                                      {ell.enroll_count.length > 0 &&
                                        ell.enroll_count
                                          .filter(
                                            (elop) => elop.gender === "Male"
                                          )
                                          .map((el) => el.gender_cnt) > 0
                                        ? ell.enroll_count
                                          .filter(
                                            (elop) => elop.gender === "Male"
                                          )
                                          .map((el) => el.gender_cnt)
                                        : "_"}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-2">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted mt-2 "
                                    >
                                      Female
                                    </label>
                                    <span className="ReviewLabel">
                                      {ell.enroll_count
                                        .filter(
                                          (elop) => elop.gender === "Female"
                                        )
                                        .map((el) => el.gender_cnt) > 0
                                        ? ell.enroll_count
                                          .filter(
                                            (elop) => elop.gender === "Female"
                                          )
                                          .map((el) => el.gender_cnt)
                                        : "_"}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-2">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted mt-2 "
                                    >
                                      Transgender
                                    </label>
                                    <span className="ReviewLabel">
                                      {ell.enroll_count
                                        .filter(
                                          (elop) =>
                                            elop.gender === "Transgender"
                                        )
                                        .map((el) => el.gender_cnt) > 0
                                        ? ell.enroll_count
                                          .filter(
                                            (elop) =>
                                              elop.gender === "Transgender"
                                          )
                                          .map((el) => el.gender_cnt)
                                        : "_"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </section>
                  </div>
                ))}
            </div>
          )}

          {type === "4" && examWiseEnroll.length > 0 && (
            <div className="row">
              <div className="col-md-12">
                <section className="StepOne">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Exam-wise Student Enrollment</p>
                      <div className="row mt-2">
                        {examWiseEnroll.length > 0 &&
                          examWiseEnroll.map((el, index) => (
                            <div className="col-md-3" key={index}>
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  {el.name}
                                </label>
                                <span className="ReviewLabel"> {el.value}</span>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          )}
          {type === "4" && (
            <div className="row">
              <div className="col-md-12">
                <section className="StepOne">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Exam Fees </p>
                      <div className="row mb-3">
                        {examDetail.map((el, index) => (
                          <div className="col-md-3" key={index}>
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                Fees for{" "}
                                {examDetail.length === 1 ? " " : `${index + 1}`}{" "}
                                {index + 1 > 1 ? "Exams" : "Exam"}
                              </label>
                              <span className="ReviewLabel">
                                {el.fees || ""}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          )}

          {type === "4" && formFields.Papers === "1" && (
            <div className="row">
              {examDetail.map((mkl, index) => (
                <div className="col-md-12">
                  <section className="StepOne">
                    {mkl.PaperDetailsSection.map((ell, ink) => (
                      <div className="row box">
                        <div className="col-md-12">
                          <p className="StepTitle">
                            Model Exam {index + 1} Paper {ink + 1} Details
                          </p>
                          <div className="row mt-2 mb-2">
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Paper Title
                                </label>
                                <span className="ReviewLabel">{ell.title}</span>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Date
                                </label>
                                <span className="ReviewLabel">
                                  {ell.date ? ell.date : "_"}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Duration (in Hours)
                                </label>
                                <span className="ReviewLabel">
                                  {ell.duration}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Time
                                </label>
                                <span className="ReviewLabel">
                                  {" "}
                                  {moment(ell.startTime, "h:mm:ss A").format(
                                    "h:mm A"
                                  )}{" "}
                                  to{" "}
                                  {moment(ell.endTime, "h:mm:ss A").format(
                                    "h:mm A"
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="forms ">
                                <label
                                  htmlFor="inputName"
                                  className="form-label text-muted mt-2 "
                                >
                                  Uploaded Exam Syllabus
                                  {ell.syllabus !== "" &&
                                    ell.syllabus !== null && (
                                      <a
                                        target="_blank"
                                        href={`${ImageUrlPrefix}/${ell.syllabus}`}
                                      >
                                        {" "}
                                        <Download className="download_icon" />
                                      </a>
                                    )}
                                </label>
                                <span className="ReviewLabel">
                                  {ell.original_syllabus_url !== null
                                    ? ell.original_syllabus_url
                                    : ""}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </section>
                </div>
              ))}
            </div>
          )}

          <div className="row">
            {oldBatch.map((el, index) => (
              <div className="col-md-12" key={index}>
                <section className="StepOne">
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">
                        Old Student Discount
                        {oldBatch.length === 1 ? " " : `- ${el.id}`}
                      </p>
                      <div className="row mb-3">
                        <div className="col-md-3">
                          <div className="forms ">
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted mt-2 "
                            >
                              Old Student Discount
                            </label>
                            <span className="ReviewLabel">
                              ₹ {el.OldDPercentage || "0"}
                            </span>
                          </div>
                        </div>
                        {el.OldDPercentage !== "" && (
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                Batch Range From
                              </label>
                              <span className="ReviewLabel">
                                {el.BatchRFrom || "_"}
                              </span>
                            </div>
                          </div>
                        )}
                        {el.OldDPercentage !== "" && (
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                Batch Range To
                              </label>
                              <span className="ReviewLabel">
                                {el.BatchRTo || "_"}
                              </span>
                            </div>
                          </div>
                        )}
                        {el.OldDPercentage !== "" && (
                          <div className="col-md-3">
                            <div className="forms ">
                              <label
                                htmlFor="inputName"
                                className="form-label text-muted mt-2 "
                              >
                                Old Student Discount Batches
                              </label>
                              <p className="ReviewLabel mb-1 mt-1">
                                {el.selectedOptions.length > 0
                                  ? el.selectedOptions
                                    .map((item) => `${item.label}`)
                                    .join(", ")
                                  : "_"}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            ))}
          </div>

          {type === "4" ||
            (type === "5" && (
              <div className="row">
                <div className="col-md-12">
                  <section className="StepOne">
                    <div className="row box">
                      <div className="col-md-12">
                        <p className="StepTitle">Special Offer Discount</p>
                        {mExamSF.length > 0 &&
                          mExamSF.map((lop, index) => (
                            <div className="row mt-2 mb-2" key={index}>
                              <div className="col-md-3">
                                <div className="forms ">
                                  <label
                                    htmlFor="inputName"
                                    className="form-label text-muted mt-2 "
                                  >
                                    Type of Discount
                                  </label>

                                  <span className="ReviewLabel">
                                    {lop.NoStudentBatch === "1" &&
                                      "For all the students enrolled in this batch"}
                                    {lop.NoStudentBatch === "2" &&
                                      "For the ongoing batches"}
                                    {lop.NoStudentBatch === "3" &&
                                      "For the first 'n' number of students"}
                                    {lop.NoStudentBatch === "4" && "None"}
                                  </span>
                                </div>
                              </div>
                              {(lop.NoStudentBatch === "1" ||
                                lop.NoStudentBatch === "3" ||
                                lop.NoStudentBatch === "2") && (
                                  <div className="col-md-3">
                                    <div className="forms ">
                                      <label
                                        htmlFor="inputName"
                                        className="form-label text-muted mt-2 "
                                      >
                                        Offer Amount
                                      </label>
                                      <span className="ReviewLabel">
                                        {lop.SOfferDis}
                                      </span>
                                    </div>
                                  </div>
                                )}

                              {lop.NoStudentBatch === "2" && (
                                <div className="col-md-3">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted mt-2 "
                                    >
                                      Applicable Batches
                                    </label>
                                    {lop.selectedOptions.length > 0
                                      ? lop.selectedOptions.map((el) => (
                                        <span className="ReviewLabel">
                                          {el.label}
                                        </span>
                                      ))
                                      : "_"}
                                  </div>
                                </div>
                              )}

                              {lop.NoStudentBatch === "3" && (
                                <div className="col-md-3">
                                  <div className="forms ">
                                    <label
                                      htmlFor="inputName"
                                      className="form-label text-muted mt-2 "
                                    >
                                      Student Count
                                    </label>
                                    <span className="ReviewLabel">
                                      {lop.StudentBatchCount}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            ))}
          <section className="StepOne">
            <div className="row box">
              <div className="col-md-12">
                <p className="StepTitle">Welcome Message</p>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div className="forms ">
                      <label
                        htmlFor="inputName"
                        className="form-label text-muted mt-2 "
                      >
                        Welcome Message
                      </label>
                      <span className="ReviewLabel">
                        {" "}
                        {formFields.message || ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {type !== "2" &&
            (type === "5" ? formFields.Papers === "1" : true) && (
              <section className="StepOne">
                <div className="row box">
                  <div className="col-md-12">
                    <p className="StepTitle" id="stec">
                      Schedule
                    </p>
                    <div className="row mt-4 mb-5">
                      <div className="col-md-12">
                        <MyCalendar
                          duration={formFields.Duration}
                          startDate={formFields.StartDate}
                          type={type}
                          batch_id={id}
                          ClassMode={formFields.ClassMode}
                          studentEmail={emails}
                          category={formFields.Category}
                          category_course_id={formFields.category_course_id} //New change
                          eventFields={eventFields}
                          startTime={formFields.Time}
                          subcategorys={formFields.subCate}
                          Courses={formFields.Course}
                          endTime={formFields.endTime}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

          <section className="StepOne">
            {((Array.isArray(menuList) && menuList.includes(131)) ||
              user_type === 1) && (
                <>
                  <div className="row box">
                    <div className="col-md-12">
                      <p className="StepTitle">Batch Students</p>
                      <div className="row pt-2 pb-2">
                        <div className="row ">
                          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                            <div class="input-group">
                              <input
                                ref={txtBSearch} //new
                                type="text"
                                class="Inputs mobileInput"
                                id="SearchInput"
                                name="SearchInput"
                                placeholder="Search by Name"
                                onKeyDown={handleSearch}
                              // value={searchTerm}
                              />
                              <span
                                class="input-group-text"
                                id="SearchInput"
                                onClick={handleSearchFocus}
                              >
                                <span
                                  className="material-icons"
                                  onClick={handleSearchFocus}
                                >
                                  search
                                </span>
                              </span>
                            </div>
                          </div>
                          {updateListData?.length > 0 ? (
                            <div className="col-md-8 col-12 ListBtn">
                              <ul class="List-Button">
                                <li class="ListBtnItems">
                                  <CustomDownloadButton
                                    headers={csvHeaders}
                                    csvListData={updateListData.map(
                                      ({
                                        pk,
                                        user_id,
                                        student_id,
                                        status,
                                        no_of_exams,
                                        batch_id,
                                        whatsapp_no,
                                        contact_type,
                                        location,
                                        district_id,
                                        serialNumber,
                                        ...rest
                                      }) => rest
                                    )}
                                    iconName=" file_download "
                                    filename={"BatchStudent.csv"}
                                    csvName="  Download as CSV"
                                  />
                                </li>
                                <li
                                  className="ListBtnItems primaryButton"
                                  onClick={generatePDF}
                                >
                                  <span className="material-icons me-1 align-middle text-white">
                                    file_download
                                  </span>
                                  Download as PDF
                                </li>
                              </ul>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {updateChipData.length > 0 ? (
                        <div className="row mt-3">
                          <div
                            className="col-md-12 col-sm-12 col-xs-12 "
                            id="paperil"
                          >
                            <Paper
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                flexWrap: "wrap",
                                listStyle: "none",
                                p: 0.5,
                                m: 0,
                              }}
                              component="ul"
                            >
                              {updateChipData.map((data, index) => {
                                let icon;
                                let key = "" + data.name;
                                return (
                                  <ListItem key={data}>
                                    <Chip
                                      icon={icon}
                                      label={key}
                                      onDelete={handleDelete(data, index)}
                                    />
                                  </ListItem>
                                );
                              })}

                              <ListItem>
                                <a
                                  className="allclear"
                                  href="javascript:void(0)"
                                  onClick={handleAllClear}
                                >
                                  Clear All Filters
                                </a>
                              </ListItem>
                            </Paper>
                          </div>
                        </div>
                      ) : (
                        <div></div>
                      )}
                      <div className="row mt-2 mx-0">
                        <div className="col-md-12 table-responsive tableMinHeight p-0 px-0">
                          <table className="table" id="example">
                            <thead>
                              <tr>
                                <th id="th" style={{ width: "5%" }}>
                                  {" "}
                                  <span
                                    className="text_th"
                                    onClick={(e) => handleSort(e, "serialNumber")}
                                  >
                                    S.No
                                  </span>
                                  <span
                                    class="material-icons align-middle"
                                    onClick={(e) => handleSort(e, "serialNumber")}
                                  >
                                    {" "}
                                    import_export{" "}
                                  </span>
                                </th>

                                <th id="th">
                                  <span
                                    className="text_th"
                                    onClick={(e) => handleSort(e, "fullname")}
                                  >
                                    Name
                                  </span>

                                  <span
                                    class="material-icons align-middle"
                                    onClick={(e) => handleSort(e, "fullname")}
                                  >
                                    {" "}
                                    import_export{" "}
                                  </span>
                                </th>

                                <th id="th">
                                  <span
                                    className="text_th"
                                    onClick={(e) => handleSort(e, "admission_id")}
                                  >
                                    {" "}
                                    Admission ID
                                  </span>
                                  <span
                                    class="material-icons align-middle"
                                    onClick={(e) => handleSort(e, "admission_id")}
                                  >
                                    {" "}
                                    import_export{" "}
                                  </span>{" "}
                                  {/* <span class="material-icons align-middle">
                              filter_list
                            </span> */}
                                </th>

                                <th id="th">
                                  <span
                                    className="text_th"
                                    onClick={(e) => handleSort(e, "phone_no")}
                                  >
                                    Phone Number
                                  </span>

                                  <span
                                    class="material-icons align-middle"
                                    onClick={(e) => handleSort(e, "phone_no")}
                                  >
                                    import_export
                                  </span>
                                  {/* <span class="material-icons align-middle">
                              filter_list
                            </span> */}
                                </th>

                                <th id="th">
                                  <span
                                    className="text_th"
                                    onClick={(e) => handleSort(e, "email")}
                                  >
                                    Email ID
                                  </span>
                                  <span
                                    class="material-icons align-middle"
                                    onClick={(e) => handleSort(e, "email")}
                                  >
                                    import_export
                                  </span>{" "}
                                  {/* <span class="material-icons align-middle">
                              filter_list
                            </span> */}
                                </th>

                                {(type === "4" || type === "5") && (
                                  <th id="th">
                                    <span
                                      className="text_th"
                                      onClick={(e) => handleSort(e, "gender")}
                                    >
                                      Gender
                                    </span>
                                    <span
                                      class="material-icons align-middle"
                                      onClick={(e) => handleSort(e, "gender")}
                                    >
                                      import_export
                                    </span>{" "}
                                    <span
                                      class={` align-middle material-icons  ${gender?.length > 0 || isOpen.gender
                                        ? "active_icons"
                                        : ""
                                        }`}
                                      onClick={(e) => handleFilter(e, "gender")}
                                    >
                                      filter_list
                                    </span>
                                    {isOpen.gender === true && (
                                      <div
                                        className="filterBoxs p-1"
                                        ref={filterGenderRef}
                                      >
                                        <div className="row mt-4">
                                          <div className="col-md-12">
                                            <div class="form-check ms-3">
                                              <input
                                                class="form-check-input"
                                                type="checkbox"
                                                name="male"
                                                value="1"
                                                id="male"
                                                checked={gender?.some(
                                                  (element) => {
                                                    if (element.name === "male") {
                                                      return true;
                                                    }
                                                    return false;
                                                  }
                                                )}
                                                onChange={(e) =>
                                                  handleCheckboxChange(e, "male")
                                                }
                                              />
                                              <label
                                                class="form-check-label "
                                                for="defaultCheck1"
                                                htmlFor="male"
                                              >
                                                Male
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row mt-2">
                                          <div className="col-md-12">
                                            <div class="form-check ms-3">
                                              <input
                                                class="form-check-input"
                                                type="checkbox"
                                                name="female"
                                                value="2"
                                                id="female"
                                                checked={gender?.some(
                                                  (element) => {
                                                    if (
                                                      element.name === "female"
                                                    ) {
                                                      return true;
                                                    }
                                                    return false;
                                                  }
                                                )}
                                                onChange={(e) =>
                                                  handleCheckboxChange(
                                                    e,
                                                    "female"
                                                  )
                                                }
                                              />
                                              <label
                                                class="form-check-label "
                                                for="defaultCheck1"
                                                htmlFor="female"
                                              >
                                                Female
                                              </label>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="row mt-2">
                                          <div className="col-md-12">
                                            <div class="form-check ms-3">
                                              <input
                                                class="form-check-input"
                                                type="checkbox"
                                                name="Transgender"
                                                value="3"
                                                id="Transgender"
                                                checked={gender?.some(
                                                  (element) => {
                                                    if (
                                                      element.name ===
                                                      "Transgender"
                                                    ) {
                                                      return true;
                                                    }
                                                    return false;
                                                  }
                                                )}
                                                onChange={(e) =>
                                                  handleCheckboxChange(
                                                    e,
                                                    "transgender"
                                                  )
                                                }
                                              />
                                              <label
                                                class="form-check-label "
                                                for="defaultCheck1"
                                                htmlFor="Transgender"
                                              >
                                                Transgender
                                              </label>
                                            </div>
                                          </div>
                                        </div>

                                        <hr />
                                        <div className="row mt-3">
                                          <div className="col-md-4  col-4 col-sm-4">
                                            <span
                                              className="clearFilter ms-2 "
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                handleClear("gender")
                                              }
                                            >
                                              Clear
                                            </span>
                                          </div>
                                          <div className="col-md-8  col-8 col-sm-8">
                                            <button
                                              className="FilterButton"
                                              onClick={() =>
                                                handleApplyFilter("gender")
                                              }
                                            >
                                              Apply Filter
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </th>
                                )}

                                {type === "5" && (
                                  <th id="th">
                                    <span
                                      className="text_th"
                                      onClick={(e) =>
                                        handleSort(e, "stud_pref_medium")
                                      }
                                    >
                                      Medium Studied
                                    </span>

                                    <span
                                      className="material-icons align-middle"
                                      onClick={(e) =>
                                        handleSort(e, "stud_pref_medium")
                                      }
                                    >
                                      import_export
                                    </span>

                                    <span
                                      className={`align-middle material-icons ${mediums?.length > 0 ||
                                        isOpen.medium_studied
                                        ? "active_icons"
                                        : ""
                                        }`}
                                      onClick={(e) =>
                                        handleFilter(e, "medium_studied")
                                      }
                                    >
                                      filter_list
                                    </span>

                                    {isOpen.medium_studied === true && (
                                      <div
                                        className="filterBoxs p-1"
                                        ref={filterMediumRef}
                                      >
                                        <div className="row mt-4">
                                          <div className="col-md-12">
                                            <div className="form-check ms-3">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name="Tamil"
                                                value="Tamil"
                                                id="Tamil"
                                                checked={mediums?.some(
                                                  (el) => el.name === "Tamil"
                                                )}
                                                onChange={(e) =>
                                                  handleCheckboxChange(
                                                    e,
                                                    "Tamil",
                                                    "medium_studied"
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor="Tamil"
                                              >
                                                Tamil
                                              </label>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="row mt-2">
                                          <div className="col-md-12">
                                            <div className="form-check ms-3">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name="English"
                                                value="English"
                                                id="English"
                                                checked={mediums?.some(
                                                  (el) => el.name === "English"
                                                )}
                                                onChange={(e) =>
                                                  handleCheckboxChange(
                                                    e,
                                                    "English",
                                                    "medium_studied"
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor="English"
                                              >
                                                English
                                              </label>
                                            </div>
                                          </div>
                                        </div>

                                        <hr />

                                        <div className="row mt-3">
                                          <div className="col-md-4 col-4">
                                            <span
                                              className="clearFilter ms-2"
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                handleClear("medium_studied")
                                              }
                                            >
                                              Clear
                                            </span>
                                          </div>

                                          <div className="col-md-8 col-8">
                                            <button
                                              className="FilterButton"
                                              onClick={() =>
                                                handleApplyFilter(
                                                  "medium_studied"
                                                )
                                              }
                                            >
                                              Apply Filter
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </th>
                                )}

                                {type === "5" && (
                                  <th id="th">
                                    <span className="text_th">Core Subject</span>
                                    <span
                                      class="material-icons align-middle"
                                      onClick={(e) =>
                                        handleSort(e, "core_subject")
                                      }
                                    >
                                      import_export
                                    </span>
                                    <span
                                      className={`align-middle material-icons ${coreSubjects.length || isOpen.core_subject
                                        ? "active_icons"
                                        : ""
                                        }`}
                                      onClick={(e) =>
                                        handleFilter(e, "core_subject")
                                      }
                                    >
                                      filter_list
                                    </span>
                                    {isOpen.core_subject === true && (
                                      <div
                                        className="filterBoxs p-1"
                                        ref={filterCoreSubjectRef}
                                      >
                                        <div className="row mt-3">
                                          <div className="col-md-12">
                                            {coreSubjectsOptions.map(
                                              (option, index) => (
                                                <div
                                                  className="form-check ms-3"
                                                  key={index}
                                                >
                                                  <input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    name={option.value}
                                                    id={`core_subject_${option.value}`}
                                                    value={option.value}
                                                    checked={coreSubjects.some(
                                                      (item) =>
                                                        item.id === option.value
                                                    )}
                                                    onChange={(e) =>
                                                      handleCheckboxChange(
                                                        e,
                                                        "core_subject"
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    class="form-check-label "
                                                    htmlFor={`core_subject_${option.value}`}
                                                  >
                                                    {option.label}
                                                  </label>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </div>

                                        <hr />

                                        <div className="row mt-3">
                                          <div className="col-md-4 col-4 col-sm-4">
                                            <span
                                              className="clearFilter ms-2"
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                handleClear("core_subject")
                                              }
                                            >
                                              Clear
                                            </span>
                                          </div>
                                          <div className="col-md-8 col-8 col-sm-8">
                                            <button
                                              className="FilterButton"
                                              onClick={() =>
                                                handleApplyFilter("core_subject")
                                              }
                                            >
                                              Apply Filter
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </th>
                                )}

                                {type === "5" && (
                                  <th id="th">
                                    <span className="text_th">
                                      No. of Interview
                                    </span>
                                    <span
                                      class="material-icons align-middle"
                                      onClick={(e) =>
                                        handleSort(e, "interview_count")
                                      }
                                    >
                                      import_export
                                    </span>
                                  </th>
                                )}

                                {type === "4" && (
                                  <th id="th">
                                    <span
                                      className="text_th"
                                      onClick={(e) =>
                                        handleSort(e, "exam_district")
                                      }
                                    >
                                      Preferred Exam District
                                    </span>
                                    <span
                                      class="material-icons align-middle"
                                      onClick={(e) =>
                                        handleSort(e, "exam_district")
                                      }
                                    >
                                      import_export
                                    </span>{" "}
                                    <span
                                      class={` align-middle material-icons  ${exam_district?.length > 0 ||
                                        isOpen.exam_district
                                        ? "active_icons"
                                        : ""
                                        }`}
                                      onClick={(e) =>
                                        handleFilter(e, "exam_district")
                                      }
                                    >
                                      filter_list
                                    </span>
                                    {isOpen.exam_district === true && (
                                      <div
                                        className="filterBoxs p-1"
                                        ref={filterExamDistrictRef}
                                      >
                                        <div className="filterBoxText">
                                          <div className="row ms-1">
                                            <div className="col-lg-12 col-md-12">
                                              <div class="input-group searchInputsss">
                                                <input
                                                  type="text"
                                                  class="Inputs "
                                                  id="SearchFilterInputs"
                                                  name="SearchFilterInputs"
                                                  placeholder="Search Here"
                                                  onKeyDown={(e) =>
                                                    handleFilterCourseSearch(e)
                                                  }
                                                />
                                                {/* <span
                                            class="input-group-text"
                                            id="SearchInput"
                                          >
                                            <span className="material-icons">
                                              search
                                            </span>
                                          </span> */}
                                              </div>
                                            </div>
                                          </div>
                                          <hr />{" "}
                                          {dexamD.map((el) => (
                                            <div className="row mt-2">
                                              <div className="col-md-12">
                                                <div class="form-check ms-3">
                                                  <input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    name={el.label} // Use el.label to set the name and value
                                                    value={el.value}
                                                    id={el.label}
                                                    checked={exam_district?.some(
                                                      (element) => {
                                                        if (
                                                          element.name ===
                                                          el.label
                                                        ) {
                                                          return true;
                                                        }
                                                        return false;
                                                      }
                                                    )}
                                                    onChange={(e) =>
                                                      handleCheckboxChange(
                                                        e,
                                                        "exam_district"
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    class="form-check-label PinkText"
                                                    for="defaultCheck1"
                                                    htmlFor={el.label}
                                                  >
                                                    {el.label}
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>

                                        <hr />
                                        <div className="row mt-3">
                                          <div className="col-md-4  col-4 col-sm-4">
                                            <span
                                              className="clearFilter ms-2 "
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                handleClear("exam_district")
                                              }
                                            >
                                              Clear
                                            </span>
                                          </div>
                                          <div className="col-md-8  col-8 col-sm-8">
                                            <button
                                              className="FilterButton"
                                              onClick={() =>
                                                handleApplyFilter("exam_district")
                                              }
                                            >
                                              Apply Filter
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </th>
                                )}

                                {type === "4" && (
                                  <th id="th">
                                    <span
                                      className="text_th"
                                      onClick={(e) =>
                                        handleSort(e, "no_of_exams")
                                      }
                                    >
                                      No. of Exams Enrolled
                                    </span>
                                    <span
                                      class="material-icons align-middle"
                                      onClick={(e) =>
                                        handleSort(e, "no_of_exams")
                                      }
                                    >
                                      import_export
                                    </span>{" "}
                                  </th>
                                )}

                                <th id="th">
                                  <span
                                    className="text_th"
                                    onClick={(e) => handleSort(e, "amount")}
                                  >
                                    {type === "4" ? "Paid Amount" : "Fee Paid"}
                                  </span>

                                  <span
                                    class="material-icons align-middle"
                                    onClick={(e) => handleSort(e, "amount")}
                                  >
                                    import_export
                                  </span>
                                  {/* <span class="material-icons align-middle">
                              filter_list
                            </span> */}
                                </th>

                                {type !== "5" && (
                                  <th id="th">
                                    <span
                                      className="text_th"
                                      onClick={(e) =>
                                        handleSort(e, "balance_amt")
                                      }
                                    >
                                      Balance Fee
                                    </span>

                                    <span
                                      className="material-icons align-middle"
                                      onClick={(e) =>
                                        handleSort(e, "balance_amt")
                                      }
                                    >
                                      import_export
                                    </span>

                                    <span
                                      className={`align-middle material-icons ${paymentMode?.length > 0 ||
                                        isOpen.balance_amt
                                        ? "active_icons"
                                        : ""
                                        }`}
                                      onClick={(e) =>
                                        handleFilter(e, "balance_amt")
                                      }
                                    >
                                      filter_list
                                    </span>

                                    {isOpen.balance_amt === true && (
                                      <div
                                        className="filterBoxs p-1"
                                        ref={filterPaymentModeRef}
                                      >
                                        <div className="row mt-4">
                                          <div className="col-md-12">
                                            <div className="form-check ms-3">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name="Full Payment"
                                                value="0"
                                                id="Full Payment"
                                                checked={paymentMode?.some(
                                                  (item) =>
                                                    item.id === "0" &&
                                                    item.type === "balance_amt"
                                                )}
                                                onChange={(e) =>
                                                  handleCheckboxChange(
                                                    e,
                                                    "balance_amt"
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor="Full Payment"
                                              >
                                                Full Payment
                                              </label>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="row mt-2">
                                          <div className="col-md-12">
                                            <div className="form-check ms-3">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name="Partial Payment"
                                                value="1"
                                                id="Partial Payment"
                                                checked={paymentMode?.some(
                                                  (item) =>
                                                    item.id === "1" &&
                                                    item.type === "balance_amt"
                                                )}
                                                onChange={(e) =>
                                                  handleCheckboxChange(
                                                    e,
                                                    "balance_amt"
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor="Partial Payment"
                                              >
                                                Partial Payment
                                              </label>
                                            </div>
                                          </div>
                                        </div>

                                        <hr />

                                        <div className="row mt-3">
                                          <div className="col-md-4 col-4 col-sm-4">
                                            <span
                                              className="clearFilter ms-2"
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                handleClear("balance_amt")
                                              }
                                            >
                                              Clear
                                            </span>
                                          </div>
                                          <div className="col-md-8 col-8 col-sm-8">
                                            <button
                                              className="FilterButton"
                                              onClick={() =>
                                                handleApplyFilter("balance_amt")
                                              }
                                            >
                                              Apply Filter
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </th>
                                )}

                                {type === "5" && (
                                  <th id="th">
                                    <span className="text_th">Applied On</span>
                                    {/* Filter icon */}
                                    <span
                                      className={`material-icons align-middle ${(appDatas &&
                                        Object.entries(appDatas).some(
                                          ([key, val]) =>
                                            key !== "name" &&
                                            val !== null &&
                                            val !== undefined &&
                                            val.toString().trim() !== ""
                                        )) ||
                                        isOpen.appliedOn
                                        ? "active_icons"
                                        : ""
                                        }`}
                                      onClick={(e) =>
                                        handleFilter(e, "appliedOn")
                                      }
                                    >
                                      filter_list
                                    </span>

                                    {/* Popup (same as working Date filter) */}
                                    {isOpen.appliedOn && (
                                      <div
                                        ref={filterCreatedDateRef}
                                        className="filterBoxs_testlist container mt-2 p-1 BathDet"
                                      >
                                        {/* From Date */}
                                        <div className="row mt-1">
                                          <div className="col-md-12">
                                            <div className="form-check p-1">
                                              <label className="d-flex form-label">
                                                From Date
                                              </label>
                                              <DatePickerSample
                                                IconInput={"filterIocnBoxInput"}
                                                class={"FilterInputs"}
                                                name={"FDate"}
                                                handleChange={
                                                  handleChangeDate_app
                                                }
                                                fieldInput={appDatas.FDate}
                                                txtAdMDob={fDatePickerRef}
                                              />
                                            </div>
                                          </div>
                                        </div>

                                        {/* To Date */}
                                        <div className="row mt-1">
                                          <div className="col-md-12">
                                            <div className="form-check p-1">
                                              <label className="d-flex form-label">
                                                To Date
                                              </label>
                                              <DatePickerSample
                                                class={"FilterInputs"}
                                                IconInput={"filterIocnBoxInput"}
                                                name={"TDate"}
                                                handleChange={
                                                  handleChangeDate_app
                                                }
                                                fieldInput={appDatas.TDate}
                                                txtAdMDob={tDatePickerRef}
                                                minDate={appDatas.FDate}
                                              />
                                            </div>
                                          </div>
                                        </div>

                                        {/* <hr /> */}

                                        {/* Clear / Apply */}
                                        <div className="borderWidth row">
                                          <ul className="List-Button">
                                            <Link
                                              to="javascript:void(0)"
                                              onClick={() =>
                                                handleClear("appliedOn")
                                              }
                                              className="secondaryButton"
                                            >
                                              Clear
                                            </Link>
                                            <li className="ListBtnItems">
                                              <Link
                                                onClick={() =>
                                                  handleApplyFilter("appliedOn")
                                                }
                                                className="primaryButton"
                                              >
                                                Apply Filter
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    )}
                                  </th>
                                )}

                                {type !== "4" && (
                                  <th id="th">
                                    <span
                                      className="text_th"
                                      onClick={(e) => handleSort(e, "class_mode")}
                                    >
                                      Application Mode
                                    </span>

                                    <span
                                      class="material-icons align-middle"
                                      onClick={(e) => handleSort(e, "class_mode")}
                                    >
                                      import_export
                                    </span>
                                    <span
                                      class={` align-middle material-icons  ${mode?.length > 0 || isOpen.mode
                                        ? "active_icons"
                                        : ""
                                        }`}
                                      onClick={(e) => handleFilter(e, "mode")}
                                    >
                                      filter_list
                                    </span>
                                    {isOpen.mode === true && (
                                      <div
                                        className="filterBoxs p-1"
                                        ref={filterModeRef}
                                      >
                                        <div className="row mt-4">
                                          <div className="col-md-12">
                                            <div class="form-check ms-3">
                                              <input
                                                class="form-check-input"
                                                type="checkbox"
                                                name="Online"
                                                value="1"
                                                id="Online"
                                                checked={mode?.some((element) => {
                                                  if (element.name === "Online") {
                                                    return true;
                                                  }
                                                  return false;
                                                })}
                                                onChange={(e) =>
                                                  handleCheckboxChange(
                                                    e,
                                                    "Online"
                                                  )
                                                }
                                              />
                                              <label
                                                class="form-check-label "
                                                for="defaultCheck1"
                                                htmlFor="Online"
                                              >
                                                Online
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row mt-2">
                                          <div className="col-md-12">
                                            <div class="form-check ms-3">
                                              <input
                                                class="form-check-input"
                                                type="checkbox"
                                                name="Classroom"
                                                value="0"
                                                id="Classroom"
                                                checked={mode?.some((element) => {
                                                  if (
                                                    element.name === "Classroom"
                                                  ) {
                                                    return true;
                                                  }
                                                  return false;
                                                })}
                                                onChange={(e) =>
                                                  handleCheckboxChange(
                                                    e,
                                                    "Classroom"
                                                  )
                                                }
                                              />
                                              <label
                                                class="form-check-label "
                                                for="defaultCheck1"
                                                htmlFor="Classroom"
                                              >
                                                Classroom
                                              </label>
                                            </div>
                                          </div>
                                        </div>

                                        <hr />
                                        <div className="row mt-3">
                                          <div className="col-md-4  col-4 col-sm-4">
                                            <span
                                              className="clearFilter ms-2 "
                                              style={{ cursor: "pointer" }}
                                              onClick={() => handleClear("mode")}
                                            >
                                              Clear
                                            </span>
                                          </div>
                                          <div className="col-md-8  col-8 col-sm-8">
                                            <button
                                              className="FilterButton"
                                              onClick={() =>
                                                handleApplyFilter("mode")
                                              }
                                            >
                                              Apply Filter
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </th>
                                )}

                                <th id="th">
                                  {" "}
                                  <span className="text_th">Action</span>{" "}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentData?.length === 0 ? (
                                <tr>
                                  <td
                                    colspan="10"
                                    style={{ textAlign: "center" }}
                                  >
                                    No records to display
                                  </td>
                                </tr>
                              ) : (
                                currentData?.map((batch, index) => (
                                  <tr key={index} title={batch.admission_id}>
                                    <td id="td">{batch.serialNumber}</td>
                                    <td id="td">{batch.fullname}</td>
                                    <td id="td">{batch.admission_id}</td>
                                    <td id="td"> {batch.phone_no}</td>
                                    <td id="td">{batch.email}</td>
                                    {(type === "4" || type === "5") && (
                                      <td id="td">{batch.gender}</td>
                                    )}
                                    {type === "4" && (
                                      <td id="td">{batch.exam_district}</td>
                                    )}
                                    {type === "4" && (
                                      <td id="td">{batch.no_of_exams}</td>
                                    )}
                                    {type === "5" && (
                                      <td id="td">{batch.stud_pref_medium}</td>
                                    )}
                                    {type === "5" && (
                                      <td id="td">{batch.core_subject}</td>
                                    )}
                                    {type === "5" && (
                                      <td id="td">{batch.no_of_exams}</td>
                                    )}

                                    <td id="td">{batch.amount}</td>

                                    {type !== "5" && (
                                      <td id="td">{batch.balance_amt}</td>
                                    )}
                                    {type === "5" && (
                                      <td id="td">
                                        {batch.created_dt
                                          ? moment(batch.created_dt).format(
                                            "DD/MM/YYYY"
                                          )
                                          : "-"}
                                      </td>
                                    )}

                                    {type !== "4" && (
                                      <td id="td">{batch.class_mode}</td>
                                    )}

                                    <td id="td">
                                      <button
                                        className="button"
                                        onClick={() => handleViewStudent(batch)}
                                      >
                                        <span class="material-icons">
                                          visibility
                                        </span>
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="row mb-2">
                        <Pagination
                          rowsPerPage={rowsPerPage}
                          handlePageCount={handlePageCount}
                          startPage={
                            updateListData && updateListData?.length > 0
                              ? currentPage * rowsPerPage + 1 - rowsPerPage
                              : 0
                          }
                          endPage={
                            updateListData && updateListData?.length > 0
                              ? updateListData?.length < currentPage * rowsPerPage
                                ? updateListData?.length
                                : currentPage * rowsPerPage
                              : 0
                          }
                          totalRecords={
                            updateListData && updateListData?.length > 0
                              ? updateListData?.length
                              : 0
                          }
                          handlePrev={(e) => handlePrev(currentPage - 1)}
                          currentPrevPage={currentPage === 1}
                          prevButton={`${ListInfo.prev_buttonViewAllbook} ${ListInfo.materialIconsRightAndLeft} me-2`}
                          handleNext={() => handleNext(currentPage + 1)}
                          currentNextPage={
                            currentPage === totalPages || totalPages == 0
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
          </section>
          {/* loader */}
          {isPaymentLoading && (
            <Dialog open={isPaymentLoading}>
              <DialogContent>
                <div style={{ margin: "15px" }}>
                  <p> We are generating the hall ticket. Please wait...</p>
                </div>
              </DialogContent>
            </Dialog>
          )}
        </div>
      </div>
    </div>
  );
}

export default ReadViewBath;
